<script>
import AawzMarkdownRender from '@modules/global/components/aawz-markdown-render/aawz-markdown-render.vue'
import { copy } from '@utils/Clipboard'
import ComposerAttachments from '@modules/aawz-intelligence-v2/components/composer-attachments/composer-attachments.vue'
import AssistantBlocks from '@modules/aawz-intelligence-v2/components/assistant-blocks/assistant-blocks.vue'
import ChatMessageFooter from '@modules/aawz-intelligence-v2/components/chat-message-footer/chat-message-footer.vue'
import ServicosCitados from '@modules/aawz-intelligence-v2/components/servicos-citados/servicos-citados.vue'
import ChatMessageFontes from '@modules/aawz-intelligence-v2/components/chat-message-fontes/chat-message-fontes.vue'
import ChatMessageFontesWeb from '@modules/aawz-intelligence-v2/components/chat-message-fontes-web/chat-message-fontes-web.vue'
import ChatMessageArtefatos from '@modules/aawz-intelligence-v2/components/chat-message-artefatos/chat-message-artefatos.vue'
import { neutralizarAncoras } from '@modules/aawz-intelligence-v2/utils/neutralizar-ancoras'
import { extrairServicosCitados } from '@modules/aawz-intelligence-v2/utils/servicos-citados'
import ManagerQuestions from '@modules/aawz-intelligence-v2/components/manager-questions/manager-questions.vue'
import AgentBadge from '@modules/aawz-intelligence-v2/components/agent-badge/agent-badge.vue'
import CartaoCabecalho from '@modules/aawz-intelligence-v2/ui-registry/cartao-cabecalho.vue'
import { extrairPerguntasAoGestor } from '@modules/aawz-intelligence-v2/utils/perguntas-ao-gestor'
import PainelDeliberacao from '@modules/aawz-intelligence-v2/components/painel-deliberacao/painel-deliberacao.vue'
import ChatMessagePlano from '@modules/aawz-intelligence-v2/components/chat-message-plano/chat-message-plano.vue'
import {
  CHAVE_DO_CARTAO_DE_BOAS_VINDAS,
  ehCartaoDeBoasVindas,
} from '@modules/aawz-intelligence-v2/ui-registry/chave-da-boas-vindas'
import {
  CHAVE_DO_CARTAO_DE_ONBOARDING,
  ehCartaoDeOnboarding,
} from '@modules/aawz-intelligence-v2/ui-registry/chave-do-onboarding'
import BuscaWeb from '@modules/aawz-intelligence-v2/components/busca-web/busca-web.vue'
import CodigoExecutado from '@modules/aawz-intelligence-v2/components/codigo-executado/codigo-executado.vue'
import ArquivoGerado from '@modules/aawz-intelligence-v2/components/arquivo-gerado/arquivo-gerado.vue'
// [spec-003 T301 / US-5] O gráfico da análise, inline na conversa — a única
// das três formas de artefato que ainda não tinha superfície nenhuma.
import GraficoDoTurno from '@modules/aawz-intelligence-v2/components/grafico-do-turno/grafico-do-turno.vue'
import { assinaturaDePlano } from '@modules/aawz-intelligence-v2/utils/encenacao-do-progresso'
import { encenacaoDoPlano } from '@modules/aawz-intelligence-v2/utils/encenacao-do-plano'
import { extrairPainel } from '@modules/aawz-intelligence-v2/utils/painel-deliberacao'
import {
  injetarBotaoTabela,
  injetarBotaoCodigo,
} from '@modules/aawz-intelligence-v2/utils/markdown-copy-actions'
import {
  PERSONAS,
  PERSONA_IA_OPERACIONAL,
} from '@modules/aawz-intelligence-v2/constants/Personas'
import {
  AGENTES,
  agenteIdPorPersona,
  getAgente,
} from '@modules/aawz-intelligence-v2/constants/Agentes'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import {
  ENTREGAS_DA_MENSAGEM,
  ROTULO_AGENTE_GENERICO,
  SALDO_ESGOTADO,
} from '@modules/aawz-intelligence-v2/constants/TextChat'
import { renderizaPartesDoTurno } from '@modules/aawz-intelligence-v2/ui-registry/partes-do-turno/renderiza-partes'
import {
  CHAVES_DE_GATE_LEGADO,
  ESTADO_APROVACAO,
  chaveDaParte,
  falhaSemCartao,
} from '@modules/aawz-intelligence-v2/ui-registry/partes-do-turno/partes'
import { reenviarUltimoTurno } from '@modules/aawz-intelligence-v2/ui-registry/execucao'
import { agruparFontes } from '@modules/aawz-intelligence-v2/utils/fontes'
// [RF-G1] Renomeado na importação: o módulo já tem um `hubDaConversa` — o
// getter de STORE (hub do turno CORRENTE, ao vivo) — e este é outra coisa: a
// função PURA que traduz `conversa.context` (legado ou D6) em hub. Os dois
// nomes iguais no mesmo módulo são o G-9 do verdict de review; o alias aqui
// evita a colisão sem esperar aquele rename.
import { hubDaConversa as hubDoContextoLegado } from '@modules/aawz-intelligence-v2/utils/agrupar-conversas'
// [spec-019 T004-delta, G-4] Régua ÚNICA do que é log versus frase — a
// mesma que o Modo de Voz usa (`apiChat.js::_falarDesfechoDeErro`), para
// que a bolha e a fala nunca divirjam sobre o MESMO erro.
import {
  COPY_ERRO_SEM_MENSAGEM,
  pareceExcecaoCrua,
  copyDoErroDoTurno,
} from '@modules/aawz-intelligence-v2/utils/copy-do-erro-do-turno'
// F-4 (review front spec-015 it.1) — 3 computeds puros extraídos para o
// irmão `chat-message.badges.js` (mesmo molde de `agentes-do-turno.js`).
import { anexosDaMensagem as separarAnexosDoTexto } from '@modules/aawz-intelligence-v2/utils/anexos-da-mensagem'
import { semLinhaDeFontesVazia } from '@modules/aawz-intelligence-v2/utils/linha-de-fontes-vazia'
import { paraItemDeAnexo } from '@modules/aawz-intelligence-v2/utils/anexo-persistido-para-item'
import { paraItemDeArtefato } from '@modules/aawz-intelligence-v2/utils/artefato-para-item'
import { entregasVisiveis } from '@modules/aawz-intelligence-v2/utils/entrega-visivel'
import { graficosEntreEntregas } from '@modules/aawz-intelligence-v2/utils/tipo-de-artefato'
import { chaveDoArquivo } from '@modules/aawz-intelligence-v2/utils/chave-de-arquivo'
import { apiArtefatos } from '@modules/aawz-intelligence-v2/api/apiArtefatos'
import { downloadBase64 } from '@utils/Download'
import { artefatosDaMensagem } from '@modules/aawz-intelligence-v2/utils/artefatos-da-conversa'
import { rotuloDoTurno } from '@modules/aawz-intelligence-v2/utils/rotulo-do-turno'
import ComandoChip from '@modules/aawz-intelligence-v2/components/comando-chip/comando-chip.vue'
import { separarComandoDaFala } from '@modules/aawz-intelligence-v2/utils/comando-na-fala'
import { COPY_CHAT_MESSAGE } from './copy'
import * as badgesPuros from './chat-message.badges'
// [11/09/2026] A revelação suave do texto — o mixin que faz o texto "digitar"
// em vez de entrar aos blocos, e que retoma na bolha persistida o que a bolha
// em streaming chegou a mostrar (ver o cabeçalho do arquivo).
import { revelacaoDoTexto } from './chat-message.revelacao'
// [17/09/2026] O tempo MÍNIMO de cada etapa na tela — o mixin que separa o
// passo corrente (recalculado a cada evento do fio) do passo ESCRITO na linha
// de raciocínio. Sem ele, três `tool_call` do mesmo lote trocam o texto em
// 330 ms e ninguém lê nenhum (ver o cabeçalho do arquivo).
import { passoDoTurnoComTempoMinimo } from './chat-message.passo'

/**
 * ★ O renderer único dos cartões do turno — spec-001 `plataforma-por-chat` [T011].
 *
 * O backend manda `ui.component: '<modulo>/<cartao>'`, o `UI_REGISTRY` (T004)
 * diz o que montar, e cartão novo passa a ser uma entrada num registry parcial
 * de módulo (T016/T017) — sem tocar nesta bolha. As partes vêm do slice
 * `toolParts` durante o turno e de `message.tool_calls[]` na mensagem
 * recarregada.
 *
 * ## Os três cartões legados NÃO passam por aqui
 *
 * `crm/servicos-citados`, `crm/perguntas-em-aberto` e
 * `consultor/painel-deliberacao` têm DONO próprio no template — `ServicosCitados`,
 * `ManagerQuestions`/`AssistantBlocks` e `PainelDeliberacao` (dentro do
 * `AssistantBlocks`). Eles carregam regras que não estão no payload da tool: a
 * persona decide se serviços aparecem (AC-4.1), o formulário só aceita escrita
 * na última mensagem (spec-007 R5), o painel exige mesa ou turno. Por isso uma
 * parte de `tool_calls` que resolva para uma dessas três chaves é DESCARTADA
 * (`CHAVES_DE_GATE_LEGADO`): sem o descarte, a mesma mensagem teria duas
 * origens para o mesmo cartão, e a persona que não mostra serviços passaria a
 * mostrá-los pela porta de trás.
 *
 * ★ No merge com a visão imersiva (27/08/2026) os três deixaram de ser
 * montados como PARTES sintéticas por esta bolha: o redesign trouxe donos
 * dedicados e mais capazes para os três (o formulário do gestor, o chip de
 * fontes, a mesa do #1961). Manter as duas montagens desenharia cada cartão
 * duas vezes.
 *
 * ## Validação é assíncrona; recusa é visível
 *
 * `resolverEntrada` é síncrono (chave, flag e estado); `validarProps` é lazy.
 * Enquanto o veredito não volta, o cartão é montado em `input-available` (o
 * esqueleto que todo cartão sabe desenhar), nunca com props não conferidos.
 * Reprovou, ou a chave não existe, ou o módulo não está liberado: entra o
 * `fallback-card` com o motivo. Dentro de uma conversa o pior desfecho não é o
 * erro — é o silêncio.
 *
 * ★ As regras de "que cartão esta parte desenha" moram em
 * `ui-registry/partes-do-turno/partes.js`, e a resolução em `renderiza-partes.js`
 * (o mixin) — três superfícies decidem sobre as mesmas partes ([I-1] do review
 * do PR #2086), e regra de tela em dois lugares é regra que diverge. Aqui fica
 * só o que é da BOLHA: quais partes entram, e em que ordem.
 *
 * ## A ordem é UMA: texto primeiro, cartões ao final — e é linear (11/09/2026)
 *
 * O backend persiste `content` (uma string) e `tool_calls[]` (outra coluna)
 * SEM ordem relativa entre os dois (`usecase_ia_crm_chat.py::_rastro_do_turno`,
 * `resource_messages.py`) — a conversa reaberta não tem como saber se o cartão
 * veio antes ou depois de um parágrafo. Então a ordem da bolha é fixa: texto,
 * depois os cartões. E o STREAMING respeita a mesma ordem: enquanto o turno
 * corre a bolha NÃO desenha cartão nenhum (`partesParaRenderizar` é vazia);
 * eles entram no `end`, pela bolha persistida, animados. Antes disto os
 * `tool-output-available` chegavam antes do texto, os três cartões subiam ao
 * topo e cada chunk de texto os empurrava para baixo (frames
 * `~/aawz-tmp/screencasts/23-06/`) — conteúdo novo inserido ACIMA do que já
 * estava na tela, a cada chunk. Quem diz que a tool está rodando é a linha de
 * raciocínio; o cartão é resultado, e resultado fecha a resposta.
 */

const DEFAULT_STORE_MODULE = 'aawz-intelligence-v2'

/**
 * ★ [task #169] Esta parte é uma proposta que o consultor pode decidir AGORA?
 *
 * Duas condições, e a segunda é o que separa este caso da regra de ordem:
 *
 * - `approval-requested` — está esperando decisão;
 * - `id_proposta` — é a rota ESTRUTURADA do Modo Agente
 *   (`POST /runs/{id}/propostas/{id}/decisao`), que `view-chat.vue::
 *   responderCartao` roteia ANTES do guard de `chatLoading`. O clique
 *   funciona com o turno em voo.
 *
 * A proposta do Modo CHAT (sem `id_proposta`) segue reservada para o `end`:
 * lá a resposta é uma MENSAGEM ("Confirmo"), e essa a superfície recusa
 * enquanto o turno corre — mostrar o botão seria o clique caindo no vazio
 * ([P1] da corrida do T023). A distinção não é de gosto: num caso o clique
 * decide, no outro ele morre.
 */
function ehPropostaDecidivelAgora(parte) {
  if (!parte || parte.state !== ESTADO_APROVACAO) return false
  return Boolean(parte.id_proposta)
}

// O estado de erro do TURNO. A régua que separa log de frase mora em
// `utils/copy-do-erro-do-turno.js` — a MESMA fonte que o Modo de Voz usa
// para decidir o que FALAR.
const ROTULO_TENTAR_DE_NOVO = 'Tentar de novo'

export default {
  name: 'IntelligenceV2ChatMessage',
  components: {
    AawzMarkdownRender,
    ComposerAttachments,
    AssistantBlocks,
    ChatMessageFooter,
    ServicosCitados,
    // ★ merge PR #2242: `OpenQuestions` saiu daqui junto com o import e o uso no
    // template, que `desenvolvimento` já havia removido (o card de perguntas em
    // aberto virou `ManagerQuestions` + o cartão do registry). Mantê-lo
    // registrado sem import deixava `no-undef` no lint.
    PainelDeliberacao,
    ChatMessagePlano,
    ChatMessageFontes,
    BuscaWeb,
    CodigoExecutado,
    ArquivoGerado,
    GraficoDoTurno,
    ChatMessageFontesWeb,
    ChatMessageArtefatos,
    ManagerQuestions,
    AgentBadge,
    CartaoCabecalho,
    ComandoChip,
  },
  mixins: [renderizaPartesDoTurno, revelacaoDoTexto, passoDoTurnoComTempoMinimo],
  props: {
    message: {
      type: Object,
      required: true,
    },
    isStreaming: {
      type: Boolean,
      default: false,
    },
    // [VERIFY-3/Q-5] Itens `{tool, toolCallId}` no IA CRM (antes: string
    // crua do nome da tool) — `toolCallId` identifica a CHAMADA, não a
    // tool, e é a chave usada no `v-for` abaixo (evita "Duplicate keys" com
    // a mesma tool chamada 2x no turno). [VERIFY-3f/3g] Este componente é
    // COMPARTILHADO com o ai-framework (`messages.vue` via `storeModule`) —
    // o store de lá (`ai-framework/store/chat/chatActions.js`) guarda
    // STRING pura, não o objeto novo; `toolCallsDecorados` (computed
    // abaixo) tolera os dois shapes.
    activeToolCalls: {
      type: Array,
      default: function() { return [] },
    },
    streamingTokens: {
      type: Array,
      default: function () {
        return []
      },
    },
    streamingThinkingSteps: {
      type: Array,
      default: function () {
        return []
      },
    },
    // Registro completo da persona. Default = IA Operacional ⇒ comportamento atual.
    persona: {
      type: Object,
      default: function () {
        return PERSONAS[PERSONA_IA_OPERACIONAL]
      },
    },
    // Só usada quando `isStreaming`: o turno ainda não virou mensagem persistida.
    streamingServicosCitados: {
      type: Array,
      default: function () {
        return []
      },
    },
    // Idem: estado reduzido do painel do turno em andamento, vindo do store.
    streamingPainel: {
      type: Object,
      default: null,
    },
    // Idem: perguntas do turno em andamento.
    streamingPerguntasAoGestor: {
      type: Array,
      default: function () {
        return []
      },
    },
    // Repassada ao cartão de serviços: é ela que faz o rascunho sair
    // personalizado em vez de estrutural.
    idConversa: {
      type: String,
      default: '',
    },
    // Modo Agente (spec-002, US-10): o `plano` do turno EM ANDAMENTO —
    // `{itens: [{id, texto, estado}], versao}`. Mesma natureza transiente de
    // `streamingPainel`: a versão persistida mora em `message.plano`. Quem
    // decide qual `versao` é a mais recente é o store (mutation
    // `SET_PLANO`) — este componente só exibe o que a prop trouxer.
    /** O cartão flutuante do painel está na tela? Se está, ele é o dono do
     * progresso e a bolha não repete o plano. Ver `itensPlano`. */
    painelDeProgressoAtivo: {
      type: Boolean,
      default: false,
    },
    streamingPlano: {
      type: Object,
      default: null,
    },
    // [T101, spec-001 `pesquisa-internet-chat`] Os três canais transientes do
    // Modo Agente que nenhum `.vue` lia — `buscaStreaming`/`codigoStreaming`/
    // `arquivoStreaming` no store. Payloads CRUS (`d_busca`/`d_codigo`/
    // `d_arquivo`); a classificação mora nos componentes/`utils`.
    //
    // Mesma natureza de `streamingPlano`: só valem com `isStreaming`; a versão
    // do turno FECHADO vem de `message.busca`/`.codigo`/`.arquivo`, gravada
    // por `apiChat::_onEventEnd`.
    streamingBusca: {
      type: Array,
      default: function () {
        return []
      },
    },
    streamingCodigo: {
      type: Array,
      default: function () {
        return []
      },
    },
    streamingArquivo: {
      type: Array,
      default: function () {
        return []
      },
    },
    // Comando que abriu o turno (`/quem-migrar`) — o pai lê da mensagem do usuário.
    comandoDoTurno: {
      type: String,
      default: null,
    },
    // Só o ÚLTIMO turno aceita resposta no formulário — ver a prop `editavel`
    // de `manager-questions`.
    isLast: {
      type: Boolean,
      default: false,
    },
    // ★ [18/09/2026] Esta bolha carrega uma etapa que já é HISTÓRICO?
    // Derivado do thread por `messages.vue` (`idDaMensagemDaEtapaCorrente`) e
    // repassado ao cartão pela MOLDURA — é fato da conversa, não do payload.
    // A pergunta é a negativa para o default poder ser `false`
    // (`vue/no-boolean-default`): superfície que não passa a prop desenha a
    // etapa aberta, que é o comportamento de sempre.
    etapaHistorica: {
      type: Boolean,
      default: false,
    },
    // ★ [owner, 21/09/2026] A fala com que a pessoa RESPONDEU ao cartão desta
    // bolha (`utils/resposta-ao-cartao-de-onboarding.js`), derivada do thread
    // por `messages.vue` e repassada pela MOLDURA — é o que esconde os botões
    // da etapa respondida e devolve as respostas ao cartão depois de um F5 e
    // no aside. Vazio quando o thread ainda não tem resposta.
    respostaDoCartao: {
      type: String,
      default: '',
    },
    // ★ [E-72] Esta bolha é a que REPRESENTA o run do Modo Agente — só ela
    // desenha os arquivos entregues no turno. Quem decide é o `messages.vue`
    // (a última bolha de assistente de cada `id_run`), porque um run pode
    // gravar mais de uma mensagem de assistente e o cartão sairia duplicado.
    // Default `false`: superfície que não passa a prop (o
    // `chat-window-messages.vue` do Atendimento) não desenha nada — é o
    // comportamento de antes desta task.
    ancoraDeArtefatos: {
      type: Boolean,
      default: false,
    },
    // Modo Agente (US-13, follow-up T043-2): o run está em `awaiting_approval`
    // — o stream continua aberto (heartbeat) esperando a decisão do card, mas
    // não há raciocínio novo em curso. Troca "Pensando..." por "Aguardando
    // sua decisão" e desliga o spinner (nada está de fato processando).
    aguardandoDecisao: {
      type: Boolean,
      default: false,
    },
    // ★ [review #2364, item C] O estado do run DESTA conversa (recortado por
    // `messages.vue::estadoDoRunDaConversa`), entregue ao cartão de
    // confirmação pela moldura (`cartao-do-chat.js::CHAVES_DA_MOLDURA`):
    // lendo o slot fixo cru, a aba B herdava o `cancelled` da A.
    estadoDoRun: {
      type: String,
      default: '',
    },
    // Respostas já enviadas para ESTE formulário, alinhadas por índice com as
    // perguntas. Vêm da mensagem `user` seguinte, que `messages.vue` retira da
    // lista para o formato de transporte não virar balão.
    respostasDoFormulario: {
      type: Array,
      default: function () {
        return []
      },
    },
    // Namespace Vuex da SUPERFÍCIE. O slice `toolParts` do turno vive nele, e
    // o drawer do Fee Fixo tem o seu — sem a prop, a bolha do Fee Fixo leria as
    // partes da conversa do chat do CRM.
    storeModule: {
      type: String,
      default: DEFAULT_STORE_MODULE,
    },
    // Catálogo de atalhos (`GET /ia-crm/atalhos`) e módulos do menu do `/`: a
    // fala `/panorama …` ou `/crm …` vira o mesmo chip do composer. Vazios =
    // texto cru, como antes.
    atalhos: {
      type: Array,
      default: function () {
        return []
      },
    },
    modulos: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  data() {
    return {
      // O "Continuar" da apresentação já foi clicado nesta bolha?
      // Ver `mostrarPerguntasAoGestor`.
      avancouNaApresentacao: false,
      // O "Tentar de novo" desta bolha já foi clicado. Estado LOCAL de propósito:
      // é do cartão, não do turno — a bolha de erro fica no thread como registro
      // do que falhou, e o botão não pode reenviar a mesma pergunta duas vezes a
      // cada clique impaciente.
      reenviando: false,
      reenviado: false,
      // [spec-008 T028] As ENTREGAS da conversa, como o servidor as devolve.
      // Estado LOCAL da bolha, e não do store, por duas razões: quem precisa
      // do dado é só ela (o índice "Entregas desta conversa" é outro eixo —
      // cartões de UI, não arquivo), e este componente é COMPARTILHADO com o
      // ai-framework/Fee Fixo, onde nenhuma action deste nome existe (§9.1:
      // dispatch de action que só existe aqui vira `unknown action type` nas
      // outras superfícies, em silêncio).
      artefatosDaConversa: [],
      // `{[chaveDoArquivo]: true}` — loading POR ITEM do download. Mapa, nunca
      // um booleano: com duas entregas na bolha, o booleano acenderia o
      // spinner nas duas e travaria o clique da que ninguém pediu.
      baixandoPorChave: {},
    }
  },
  computed: {
    textos() {
      return COPY_CHAT_MESSAGE
    },
    isUser() {
      return this.message && this.message.role === 'user'
    },
    /**
     * Anexos que o gestor mandou NESTA sessão.
     *
     * ⚠️ Só existem no eco local: o `POST /chat` não carrega arquivo e o
     * `GET /messages` não devolve nenhum, então a mesma conversa reaberta volta
     * sem eles. É assimetria viva/reaberta conhecida, e ela some junto com o
     * recurso no escritório sem a funcionalidade `IA - Analise Agentica`
     * (`utils/anexos-liberados.js`, spec-003 T306).
     */
    anexosDaMensagem() {
      return (this.message && this.message.anexos) || []
    },
    temAnexos() {
      return this.anexosDaMensagem.length > 0
    },
    /**
     * O bloco técnico de anexos que sobrevive ao F5 (spec-016 [T023-back])
     * — quando `anexosDaMensagem` (eco local, acima)
     * já esvaziou, é daqui que a bolha reaberta sabe que houve anexo.
     *
     * `content` já vem SEM o bloco (o computed abaixo faz o strip); guardo
     * o resultado aqui para não rodar o parser duas vezes por render.
     */
    anexosPersistidosDaMensagem() {
      if (!this.isUser) return []
      return separarAnexosDoTexto((this.message && this.message.content) || '').anexos
    },
    /**
     * [S-3, design-conformance 05/09] Os anexos persistidos, no MESMO shape
     * que `ComposerAttachments` já usa para o anexo AO VIVO
     * (`anexosDaMensagem` acima) — antes deste fix o persistido desenhava
     * num componente à parte (`AnexosPersistidosChips`, chip "📎 nome"), a
     * MESMA informação com uma anatomia diferente na MESMA bolha.
     */
    itensDeAnexosPersistidos() {
      return this.anexosPersistidosDaMensagem.map(paraItemDeAnexo)
    },
    temAnexosPersistidos() {
      return this.itensDeAnexosPersistidos.length > 0
    },
    /**
     * [spec-008 T028] O run que produziu ESTE turno.
     *
     * `GET /messages` devolve `id_run` por mensagem (`resource_messages.py`,
     * atributo declarado na leitura) e `apiChat._onEventEnd` o carimba na
     * mensagem criada ao vivo — é a chave que liga a entrega ao turno que a
     * produziu. `null` em toda mensagem do Modo Chat, que não tem run.
     */
    idRunDaMensagem() {
      return (this.message && this.message.id_run) || null
    },
    /**
     * As ENTREGAS deste turno — o arquivo que o agente produziu (planilha,
     * apresentação, PDF) e que o consultor precisa baixar (US-4).
     *
     * ★ Filtra pelo `id_run` da PRÓPRIA mensagem: a listagem é da conversa
     * inteira, e sem o recorte toda bolha de agente mostraria a entrega de
     * todas as outras — a mesma planilha repetida em cinco turnos.
     *
     * O shape é o de `ComposerAttachments` (`{name, size, type}`), pelo
     * adaptador — é o MESMO componente que a bolha do usuário já usa para o
     * anexo, e desenhar arquivo em duas anatomias na mesma conversa foi o
     * defeito que o S-3 corrigiu do outro lado.
     */
    entregasDoTurno() {
      if (!this.idRunDaMensagem) return []
      return this.artefatosDaConversa
        .filter((artefato) => artefato && artefato.id_run === this.idRunDaMensagem)
        .map(paraItemDeArtefato)
    },
    temEntregas() {
      return this.entregasDoTurno.length > 0
    },
    /**
     * [spec-003 T301 / US-5] As entregas deste turno que são GRÁFICO.
     *
     * São as mesmas entregas da lista abaixo — o gráfico continua sendo um
     * artefato baixável como os outros; o que muda é que ele TAMBÉM aparece na
     * conversa, que é o que a US-5 pede ("exibi-lo inline no chat como PNG e
     * disponibilizá-lo também como artefato baixável").
     */
    graficosDoTurno() {
      return graficosEntreEntregas(this.entregasDoTurno)
    },
    tituloDasEntregas() {
      return ENTREGAS_DA_MENSAGEM.TITULO
    },
    isAssistant() {
      return this.message && this.message.role === 'assistant'
    },
    // `{rotulo, icone, argumento}` quando a fala do usuário é um comando do `/`.
    comandoDaFala() {
      if (!this.isUser) return null
      return separarComandoDaFala(this.content, this.atalhos, this.modulos)
    },
    /**
     * O plano DESTE turno ainda está sendo revelado no cartão/na bolha
     * (`utils/encenacao-do-plano.js`, §5.1). Enquanto isso a bolha mostra só o
     * plano andando: o texto (e, por tabela, os cartões, que já esperam o
     * texto) entram quando a última etapa assenta — a fila tem teto de 2s.
     * Turno lento não segura nada (a fila acompanha a realidade e não está
     * drenando), histórico nunca (assinatura diferente), e
     * `prefers-reduced-motion`/cancelamento/troca de conversa zeram o relógio.
     */
    // Encenar só na bolha do turno corrente: a que está em streaming, ou a
    // persistida que acabou de nascer dele (`duracao_s`) e fecha a conversa.
    planoEncenavel() {
      if (this.isUser) return false
      return this.isStreaming || (this.isLast && this.cartoesEntramAnimados)
    },
    /**
     * Os itens do plano DO TURNO — a fonte da assinatura da encenação.
     *
     * ⚠️ [20/09/2026] NÃO é o `itensPlano`, e a diferença apagava a encenação
     * inteira: aquele é a lista que a bolha DESENHA, e ela devolve `[]` de
     * propósito quando o cartão flutuante está ligado (um indicador por tela).
     * Como `aguardandoEncenacaoDoPlano` lia dele, a guarda `if (!itens.length)`
     * saía `false` em TODA bolha da Home IA — o texto e os cartões entravam no
     * mesmo quadro do `end`, com o progresso ainda andando no cartão ao lado.
     * Medido na tela em 20/09/2026 (`/quem-migrar`: plano com 2 etapas
     * encenando e a resposta de 1.795 chars já inteira).
     *
     * Ler o PLANO em vez da lista de desenho separa as duas perguntas: "o que
     * esta bolha desenha" (nada, o cartão desenha) e "o que este turno está
     * encenando" (as etapas do plano).
     */
    itensDoPlanoDoTurno() {
      return (this.plano && this.plano.itens) || []
    },
    aguardandoEncenacaoDoPlano() {
      if (this.isUser) return false
      if (!this.planoEncenavel) return false
      const itens = this.itensDoPlanoDoTurno
      if (!itens.length) return false
      const assinatura = assinaturaDePlano(itens.map((item) => item.texto))
      if (assinatura !== encenacaoDoPlano.assinatura) return false
      return encenacaoDoPlano.revelados < encenacaoDoPlano.alvo
    },
    content() {
      if (this.aguardandoEncenacaoDoPlano) return ''
      // ⚠️ O texto do MARCADOR não vai à tela quando o cartão que ele marca
      // está desenhado nesta bolha. O servidor grava um `content` curto
      // ("Boas-vindas ao AAWZ.") porque `content: ''` persistido envenena o
      // histórico dos turnos seguintes — ele existe para o BANCO, não para o
      // olho. Com o cartão presente, ele vira uma linha solta repetindo, em
      // pior, o "Olá <Nome>, bem-vindo ao AAWZ Hub" logo abaixo (achado do
      // owner, 18/09/2026).
      if (this.temCartaoQueSubstituiOTexto) return ''
      if (this.isStreaming && this.streamingTokens.length) {
        return semLinhaDeFontesVazia(this.textoDosTokens(this.streamingTokens))
      }
      const bruto = (this.message && this.message.content) || ''
      // O strip de anexos é só da bolha do USUÁRIO: o assistente nunca escreve
      // o bloco, e rodar o parser nele à toa (`conteudoRenderizado` reusa
      // `content`) seria trabalho sem efeito, não um risco — mas o `isUser`
      // aqui evita até esse custo. A bolha do assistente só perde a linha
      // final "Fontes: —" vazia (`linha-de-fontes-vazia.js`).
      if (!this.isUser) return semLinhaDeFontesVazia(bruto)
      return separarAnexosDoTexto(bruto).texto
    },
    // Modo Agente (US-10/US-13): plano do turno — streaming ou persistido em
    // `message.plano`. Mesmo padrão de `painel`/`streamingPainel`.
    plano() {
      if (this.isStreaming) return this.streamingPlano
      return (this.message && this.message.plano) || null
    },
    // Itens crus do plano — a decoração (ícone/cor por estado) e o
    // colapsar/expandir moraram pra `chat-message-plano.vue` (VERIFY-3b).
    /**
     * Esta bolha carrega um cartão que JÁ diz o que o `content` diria?
     *
     * Hoje são os dois cartões da APRESENTAÇÃO: o player da boas-vindas traz
     * a saudação inteira, e cada etapa do onboarding traz o próprio título e
     * descrição — o marcador do servidor ao lado deles é ruído
     * ("Etapa da apresentacao do AAWZ." em cima do cartão que já diz qual
     * etapa é, achado do owner em 18/09/2026). A lista é
     * explícita de propósito — "todo cartão substitui o texto" não é verdade
     * (um cartão de tarefas não fala pela resposta que o modelo escreveu).
     */
    temCartaoQueSubstituiOTexto() {
      const partes = this.partesResolvidas || []
      return partes.some(
        (parte) =>
          parte &&
          (parte.chave === CHAVE_DO_CARTAO_DE_BOAS_VINDAS ||
            parte.chave === CHAVE_DO_CARTAO_DE_ONBOARDING)
      )
    },
    itensPlano() {
      // ⚠️ UM indicador de progresso por tela. Com o cartão flutuante do
      // painel ligado, ele é a superfície do progresso — e o card "Plano" na
      // bolha passa a dizer o MESMO em dois lugares (achado do owner na tela,
      // 18/09/2026, com o onboarding: 4 etapas no painel à direita e o mesmo
      // "0 de 4 etapas" dentro da bolha). Mesma régua do "um indicador por
      // vez" que tirou a pílula de fase e o card de raciocínio.
      //
      // Opt-in: sem a prop, a bolha desenha o plano como sempre desenhou (é o
      // caso do Modo Agente nas superfícies sem o painel).
      if (this.painelDeProgressoAtivo) return []
      return (this.plano && this.plano.itens) || []
    },
    // [T101] Os três canais do turno — mesma forma de `plano`: ao vivo vêm do
    // store (props), no turno fechado saem da mensagem.
    //
    // ⚠️ `|| []`, nunca `|| null`: os componentes declaram `Array` e um `null`
    // explícito NÃO cai no `default` de uma prop do Vue 2 (só `undefined` cai),
    // o que dispararia warning de tipo em toda mensagem antiga.
    eventosDeBusca() {
      if (this.isStreaming) return this.streamingBusca
      return (this.message && this.message.busca) || []
    },
    eventosDeCodigo() {
      if (this.isStreaming) return this.streamingCodigo
      return (this.message && this.message.codigo) || []
    },
    /**
     * ★ [21/09/2026] `entregasVisiveis` corta o `tipo: 'manifesto'` — o snapshot interno
     * do workspace do worker. O owner mandou o print de um turno que FALHOU mostrando
     * "_workspace/snapshot.tar.gz — manifesto · arquivo · 45 B" sob "Arquivos gerados":
     * um tar.gz vazio, estado do worker, anunciado ao consultor como entrega.
     *
     * A régua já existia do outro lado — `artefatos_autorizacao.py::TIPOS_ENTREGAVEIS`
     * é `{'anexo', 'artefato'}` e a listagem de Entregas filtra por ela. Só o cartão de
     * streaming não filtrava, então o mesmo snapshot que o download escondia aparecia
     * aqui. O filtro vive num util para as duas pontas (ao vivo e persistida, que
     * passam por ESTE computed) usarem a mesma decisão.
     */
    eventosDeArquivo() {
      if (this.isStreaming) return entregasVisiveis(this.streamingArquivo)
      return entregasVisiveis((this.message && this.message.arquivo) || [])
    },
    thinkingSteps() {
      if (this.isStreaming && this.streamingThinkingSteps.length) {
        return this.streamingThinkingSteps
      }
      const msg = this.message
      return (msg && msg.thinking_steps) || []
    },
    sources() {
      const msg = this.message
      return (msg && msg.sources) || []
    },
    /**
     * Há fonte com o que DIZER ([G-6] do QA da spec-001).
     *
     * O QA mediu `Fontes: ()` na tela: a lista não estava vazia, mas o item não
     * tinha `tabela`. Quem decide é o MESMO `agruparFontes` que o
     * `chat-message-fontes` usa para montar as pílulas (ele já descarta o item
     * sem tabela) — contar aqui por outra régua faria o rótulo aparecer sobre
     * um popover vazio.
     */
    hasSources() {
      return agruparFontes(this.sources).length > 0
    },
    // AawzMarkdownRender já roda DOMPurify quando `allow-html` está ligado
    // (mesma condição de `persona.permiteHtml` aqui) — um sanitizer regex
    // prévio (`sanitize-ia-html.js`, removido) era uma segunda passada
    // redundante, não uma camada de segurança adicional.
    // [11/09/2026] Durante a revelação suave é o PREFIXO exibido (com a
    // ênfase aberta fechada) — fora dela, `content` intacto, como sempre
    // (`chat-message.revelacao.js`).
    conteudoRenderizado() {
      return this.textoParaRenderizar
    },
    linkifyAtivo() {
      return !this.persona.neutralizaAncoras
    },
    // AawzMarkdownRender já apara linhas em branco sobrando em blocos de
    // código sozinho — aqui só precisamos fornecer o extra específico desta
    // persona (neutralizar âncoras), quando aplicável.
    postrenderExtra() {
      if (this.persona.neutralizaAncoras) return neutralizarAncoras
      return null
    },
    servicosCitados() {
      if (this.isStreaming) return this.streamingServicosCitados
      return extrairServicosCitados(this.message)
    },
    // Mesma forma de `servicosCitados`: ao vivo vem do store, reaberta sai do
    // `tool_calls` da mensagem.
    perguntasAoGestor() {
      if (this.isStreaming) return this.streamingPerguntasAoGestor
      return extrairPerguntasAoGestor(this.message)
    },
    // [15/09/2026] A MESMA regra dos cartões (`partesParaRenderizar`): o
    // formulário só entra no `end`, depois que o texto parou de crescer — em
    // streaming ele nascia no meio do turno e o texto ia empurrando-o para
    // baixo (feedback do usuário). Entra animado pelo `iv2-parte`.
    mostrarPerguntasAoGestor() {
      if (this.isStreaming || this.revelacaoAtiva) return false
      // ★ Na bolha da APRESENTAÇÃO, o formulário só entra depois do
      //   "Continuar" (owner, 18/09/2026: *"só a partir dele que vamos
      //   mostrar o componente de perguntas... senão fica muita coisa na cara
      //   e não fica no esquema de etapas"*). A apresentação e o formulário
      //   chegam no MESMO turno — é o botão que os separa em dois passos.
      //
      //   ⚠️ Vale só onde a apresentação está: numa bolha comum,
      //   `temCartaoQueSubstituiOTexto` é falso e o formulário entra como
      //   sempre entrou.
      if (this.temCartaoQueSubstituiOTexto && !this.avancouNaApresentacao) {
        return false
      }
      return this.perguntasAoGestor.length > 0
    },
    // Respondido nunca volta a ser editável — reeditar mandaria a resposta para
    // o fim da conversa, longe da pergunta.
    perguntasEditaveis() {
      if (this.respostasDoFormulario.length) return false
      return this.isLast && !this.isStreaming
    },
    // O raciocínio da triage (G11): por que ESTA mesa foi escolhida.
    racionalDoPainel() {
      return (this.painel && this.painel.racional) || ''
    },
    // Os passos que a linha de raciocínio (`raciocinio-linha`) lista ao
    // expandir — o store guarda um por evento `thinking`, a mensagem persistida
    // os traz em `thinking_steps`.
    //
    // Duas fontes, nesta ordem: o racional da triage primeiro (é a análise), as
    // linhas "Consultando <tool>..." depois. As linhas de tool NÃO são
    // descartadas — na rota IA Operacional, que nunca convoca painel, elas são o
    // único raciocínio que existe.
    passosDoRaciocinio() {
      return [this.racionalDoPainel, ...this.thinkingSteps].filter(Boolean)
    },
    // A duração do turno gravada por `apiChat._onEventEnd` (`duracao_s`) —
    // `null` na mensagem do histórico, que o backend não carimba.
    duracaoDoTurno() {
      const valor = this.message && this.message.duracao_s
      return typeof valor === 'number' ? valor : null
    },
    // O auxiliar barato de cada passo da lista de raciocínio, por rótulo:
    // o MESMO texto que a prévia de artefato já calcula para a parte
    // (`parteDoConteudoDoArtefato` — "1.667 linhas", o nome do cliente).
    // Rótulo que aparece em mais de uma parte com textos diferentes fica sem
    // auxiliar: agrupado em "· 15×", um nome só mentiria sobre os outros 14.
    auxiliaresDoRaciocinio() {
      const mapa = {}
      const self = this
      this.partesResolvidas.forEach(function (parte) {
        if (!parte || !parte.label) return
        const props = parte.parteReal ? parte.parteReal.props : parte.props
        const texto = self.parteDoConteudoDoArtefato(props) || ''
        if (!Object.prototype.hasOwnProperty.call(mapa, parte.label)) {
          mapa[parte.label] = texto
          return
        }
        if (mapa[parte.label] !== texto) mapa[parte.label] = ''
      })
      return mapa
    },
    // Mesma forma de `servicosCitados` — ao vivo vem do store, reaberta sai da
    // mensagem persistida. ★ Depois do merge com o `desenvolvimento`, os dois
    // caminhos entregam a TRANSCRIÇÃO CRUA: o painel que ficou é o do #1961, e
    // quem reduz é o `painelParcialStreaming` (getter) ou o próprio
    // `painel-deliberacao`. Não há mais adaptador no meio.
    painel() {
      if (this.isStreaming) return this.streamingPainel
      return extrairPainel(this.message)
    },
    /**
     * A bolha ainda está TRABALHANDO aos olhos de quem lê.
     *
     * ★ [20/09/2026] Inclui a janela da encenação. Sem isto, o turno terminava
     * (`isStreaming` cai), o texto ficava retido pela fila e a bolha aparecia
     * como um casco PRONTO e vazio — só o badge do agente, o chip de Fontes e
     * os polegares, sem uma linha de texto e sem indicador nenhum (achado do
     * owner na tela, com print). Ele pediu o oposto: *"não deveria aparecer o
     * 'pensando…'? sem os fontes…"*.
     */
    trabalhando() {
      return this.isStreaming || this.aguardandoEncenacaoDoPlano
    },
    // ⚠️ A guarda aqui é `aguardandoEncenacaoDoPlano`, NUNCA `trabalhando`:
    // durante o streaming normal os serviços citados aparecem assim que a tool
    // os devolve, e escondê-los ali mudaria um comportamento que ninguém
    // pediu (há teste de paridade ao vivo × reaberta que mede exatamente isso).
    mostrarServicosCitados() {
      if (this.aguardandoEncenacaoDoPlano) return false
      return (
        this.persona.mostraServicosCitados && this.servicosCitados.length > 0
      )
    },
    mostrarFontes() {
      // Fontes é o RODAPÉ do que já foi dito: com o texto retido pela fila da
      // encenação, ele aparecia ANTES da resposta que explica de onde o dado
      // saiu — o casco vazio do print do owner.
      if (this.aguardandoEncenacaoDoPlano) return false
      return this.hasSources && this.persona.mostraFontes
    },
    messageId() {
      return (this.message && this.message.id) || null
    },
    currentFeedback() {
      return (this.message && this.message.feedback) || null
    },
    // [spec-011 T003] Comentário já persistido do feedback — mostrado ao
    // reabrir a conversa (`_mensagens.feedback_comentario`, migration v634).
    currentComentario() {
      return (this.message && this.message.feedback_comentario) || null
    },

    // ── D6 — quem respondeu, por mensagem (spec-010, [T027]/US-7) ───────────
    //
    // ★ DIVERGÊNCIA FECHADA (RF-G2 do verdict de review front) — turno
    // multi-agente agora mostra UM badge POR `DomainResult` (spec.md:186),
    // não só o primeiro. A divergência ORIGINAL (registrada aqui até este
    // fix) era: `_onAgentSelected` (`apiChat.js`) guardava só o PRIMEIRO
    // agente do fan-out; o `finish.agentes[]` só trazia SLUGS (sem hub/
    // motivo) num estado TRANSIENTE (`finishDoTurno`) que nunca chegava a
    // `agentePorMensagem` — renderizar N badges a partir daquilo inventaria
    // hub/motivo ou só cobriria a janela do streaming. O fix (spec-010,
    // RF-G2) tocou os 3 lados: `apiChat.js` acumula `_agentesDoTurno[]`
    // completo (dedupe por slug, com hub/motivo de cada `agent-selected`) e
    // espelha ao vivo em `agentesDoTurnoAoVivo`; `store/{mutations,actions,
    // getters}.js` persiste o array em `agentePorMensagem[id].agentes` no
    // `end` e expõe os getters `agentesDaMensagem`/`agentesDoTurnoAoVivo`;
    // este componente lê os dois em `badgesDoTurno` (abaixo) e itera no
    // template. Limitação que PERMANECE, fora deste escopo: no reload, uma
    // mensagem gravada antes do Supervisor existir (ou com `IA_SUPERVISOR_
    // ATIVO` desligada) ainda cai no hub do CONTEXTO da conversa (RF-G1),
    // sem agente nenhum — não é regressão desta task, é a mesma régua de
    // sempre para turno sem `agent_slug`.
    /**
     * O registro de `agentePorMensagem` para ESTA mensagem — `null` quando
     * não há entrada (turno gravado antes do Supervisor existir, ou mensagem
     * ainda sem id persistido). Lido direto do `storeModule`, mesmo padrão de
     * `toolPartsDoTurno` logo abaixo: o getter `agenteDaMensagem` ([T028]) é
     * função-de-função — `{agentSlug, hub, motivo}` por id — feito para não
     * precisar passar o mapa inteiro por prop a cada mensagem.
     */
    agenteDoTurno() {
      if (!this.messageId) return null
      const store = this.$store
      if (!store) return null
      const buscar = store.getters[this.storeModule + '/agenteDaMensagem']
      if (!buscar) return null
      return buscar(this.messageId)
    },
    // F-4 (review front spec-015 it.1) — as 3 computeds de badge que
    // liam/derivavam `agentesDaMensagem`/`agentesDoTurnoAoVivo` foram
    // extraídas para o irmão `chat-message.badges.js` (funções PURAS, mesmo
    // molde de `agentes-do-turno.js`). Aqui só injetam o que o componente já
    // tem (`this.$store`, `this.storeModule`, ...) — a lógica/WHY completos
    // vivem no arquivo extraído.
    agentesDaMensagemAtual() {
      return badgesPuros.agentesDaMensagemAtual({
        store: this.$store,
        storeModule: this.storeModule,
        messageId: this.messageId,
        agenteDoTurno: this.agenteDoTurno,
      })
    },
    agentesEmStreamingAtual() {
      return badgesPuros.agentesEmStreamingAtual({ store: this.$store, storeModule: this.storeModule })
    },
    /**
     * [feedback do usuário] Empilhar 3 indicadores de "trabalhando" na MESMA
     * bolha ao mesmo tempo (este badge em `carregando`, o accordion de
     * raciocínio vazio e o texto fixo do rodapé) lia feio — o ChatGPT mostra
     * um indicador só, com o texto trocando. O badge deixou de aparecer
     * durante o "roteando…": ele só sobe quando `hubDoTurno` já resolveu de
     * verdade (mapa → `agent-selected`/pino, ver `hubDoTurno` abaixo — em
     * streaming normal ele fica vazio até o Supervisor rotear; só no turno
     * PINADO o hub já vem no `start`, e aí o badge aparece desde o início,
     * porque já é um fato, não um placeholder). O vácuo inicial (turno em
     * streaming sem hub resolvido ainda) passa a ser coberto só pela linha
     * de raciocínio (`passoAtualDoTurno`, que lê a fase ao vivo do turno).
     *
     * [RF-G1] do verdict de review, ainda válido fora do streaming: o badge
     * só aparece quando HÁ hub pra afirmar — `hubDoTurno` abaixo sempre
     * resolve um (mapa → contexto da conversa), então este guard só protege
     * o dia em que `persona` genuinamente faltar.
     */
    mostrarAgenteBadge() {
      if (!this.isAssistant) return false
      return Boolean(this.hubDoTurno)
    },
    /**
     * Hub do turno EM STREAMING ([G-1]): sem `messageId` ainda não há como
     * indexar `agentePorMensagem` — lê direto o `hubDaConversa` do
     * `storeModule`, que `apiChat` já atualiza ao vivo (`start` do turno
     * pinado, ou `agent-selected` assim que o Supervisor roteia — ver o
     * comentário de `_onAgentSelected`). `null`/ausência de store viram
     * string vazia, mesmo contrato de `hubDoTurno` abaixo.
     */
    hubEmStreaming() {
      const store = this.$store
      if (!store) return ''
      return store.getters[this.storeModule + '/hubDaConversa'] || ''
    },
    /**
     * `hub` pode vir `null` no state (D6: "ainda não roteado" é estado
     * legítimo — `getters.js`) — nunca repassado cru ao prop `String` do
     * badge, senão o Vue acusa tipo errado.
     *
     * [RF-G1] do verdict de review front: turno antigo sem entrada em
     * `agentePorMensagem` (flag `IA_SUPERVISOR_ATIVO` desligada, ou mensagem
     * gravada antes de `_agentes`/`agent_slug` existirem) NÃO cai mais no
     * default cego de `getHub('')` — isso fazia toda bolha afirmar "Hub do
     * Profissional", inclusive em conversas do Consultor Estratégico, que o
     * backend mapeia para `gestao`. O hub vem do CONTEXTO DA CONVERSA: a
     * `persona` ativa É o `context` persistido (`restaurarEstadoDaConversa`
     * em `view-chat.vue` garante isso — a persona segue a conversa aberta),
     * e `hubDoContextoLegado` (o `hubDaConversa` de `agrupar-conversas.js`)
     * já faz essa tradução para o chip da lateral (`conversation-row.vue`) e
     * para o agrupamento por hub — reusar em vez de reimplementar.
     */
    hubDoTurno() {
      if (this.isStreaming) return this.hubEmStreaming
      const doMapa = this.agenteDoTurno && this.agenteDoTurno.hub
      if (doMapa) return doMapa
      return hubDoContextoLegado(this.persona && this.persona.id)
    },
    // F-4 (review front spec-015 it.1) — lista de badges A RENDERIZAR,
    // extraída para `chat-message.badges.js` (é ela que decide o ESTADO de
    // cada badge — carregando/erro/sucesso/vazio).
    // Fecha a DIVERGÊNCIA DECLARADA no comentário de `agenteDoTurno` acima:
    // turno multi-agente mostra N badges, não 1.
    badgesDoTurno() {
      return badgesPuros.badgesDoTurno({
        isStreaming: this.isStreaming,
        hubEmStreaming: this.hubEmStreaming,
        hubDoTurno: this.hubDoTurno,
        erroDoTurno: this.erroDoTurno,
        agentesEmStreaming: this.agentesEmStreamingAtual,
        agentesDaMensagem: this.agentesDaMensagemAtual,
        rotuloDeFallback: this.rotuloDoAgenteSemResolucao,
      })
    },
    // ── Rótulo do agente quando o turno NÃO resolveu nenhum ─────────────────
    //
    // A bolha de erro do turno (§10 do CLAUDE.md) nasce de um turno que morreu
    // ANTES do `agent-selected`: nunca há entrada em `agentePorMensagem` (e ela
    // nem tem `id` para indexar). O badge em `erro` mostrava um traço literal
    // ao lado da marca. A cascata abaixo diz quem DEVERIA ter respondido.
    /**
     * 1º degrau — o agente ativo da conversa, o MESMO que composer/sidebar
     * mostram. `agenteAtivoId` só é publicado pela superfície de navegação
     * (`view-chat.vue::publicarAgenteAtivo`) e só existe neste namespace:
     * noutro `storeModule` (Fee Fixo, ai-framework) o getter não existe e
     * cai em vazio, sem erro.
     */
    rotuloDoAgenteAtivo() {
      const store = this.$store
      if (!store) return ''
      const agenteId = store.getters[this.storeModule + '/agenteAtivoId']
      if (!agenteId) return ''
      return getAgente(agenteId).label
    },
    /**
     * 2º degrau — o agente PRINCIPAL da persona da conversa (`principalDaPersona`
     * desempata Painel × Consultor, que dividem a mesma). Guardado pela
     * existência no catálogo: `agenteIdPorPersona` cai no default para persona
     * desconhecida, e afirmar "IA Operacional" numa conversa da Central de IA
     * seria inventar um agente.
     */
    rotuloDoAgentePrincipalDaPersona() {
      const personaId = this.persona && this.persona.id
      if (!personaId) return ''
      const temAgente = AGENTES.some((agente) => agente.persona === personaId)
      if (!temAgente) return ''
      return getAgente(agenteIdPorPersona(personaId)).label
    },
    rotuloDoAgenteSemResolucao() {
      return (
        this.rotuloDoAgenteAtivo ||
        this.rotuloDoAgentePrincipalDaPersona ||
        ROTULO_AGENTE_GENERICO
      )
    },

    // ── As partes do turno (spec-001 `plataforma-por-chat`, [T011]) ─────────
    //
    // ★ [11/09/2026] A bolha em STREAMING não desenha cartão nenhum — os
    // cartões ficam RESERVADOS até o `end`, quando a bolha persistida os
    // desenha abaixo do texto (ver "A ordem é UMA" no cabeçalho). O slice
    // `toolParts` do turno continua sendo lido, mas por `partePorId`
    // (`renderiza-partes.js`): é a parte VIVA que vence a cópia da mensagem
    // depois do `end`, e é ela que muda no clique.
    //
    // Uma parte por chamada persistida. `tool_calls[].id` pode vir nulo em
    // mensagem antiga — o índice completa a identidade para o `:key`.
    /**
     * ★ [task #169] As partes que ESPERAM DECISÃO, durante o turno.
     *
     * A regra de ordem (11/09) reserva cada cartão para o `end`, para o texto
     * que chega não empurrar resultado já desenhado. No Modo Agente isso
     * criava um laço fechado: em `awaiting_approval` o relay fica aberto em
     * heartbeat até a decisão (US-5/E-22), então o `end` **depende** do
     * clique — e o cartão que recebe o clique só apareceria depois do `end`.
     *
     * Medido no run `12d4b333` (16/09/2026): 3 `confirmacao` nos seq 18/21/22,
     * `end` só no seq 27, DEPOIS de o consultor desistir e cancelar. Ele viu o
     * chip "3 propostas abertas" e nenhum botão por 239 s.
     *
     * A proposta não é resultado: é a razão pela qual o turno está parado.
     * Ela entra agora; o resto continua esperando o `end`.
     */
    partesAguardandoDecisao() {
      const getters = this.$store && this.$store.getters
      const doSlice = (getters && getters[this.storeModule + '/toolPartsOrdenadas']) || []
      return doSlice.filter(ehPropostaDecidivelAgora)
    },
    partesDeToolCalls() {
      if (this.isStreaming) return this.partesAguardandoDecisao
      const chamadas = (this.message && this.message.tool_calls) || []
      const self = this
      return chamadas.map(function (chamada, indice) {
        return self.parteDaChamada(chamada || {}, indice)
      })
    },
    partesDeTools() {
      return this.partesDeToolCalls.filter(function (parte) {
        // Erro de tool nunca é silencioso — nem sem chave, nem sob gate legado.
        if (falhaSemCartao(parte)) return true
        const chave = chaveDaParte(parte)
        if (!chave) return false
        return CHAVES_DE_GATE_LEGADO.indexOf(chave) === -1
      })
    },
    /**
     * O contrato do mixin: as partes desta bolha, na ordem da tela.
     *
     * Só os cartões das TOOLS. Painel, serviços citados e perguntas têm dono
     * dedicado no template (ver o bloco no topo do arquivo). Vazia enquanto o
     * turno corre — os cartões entram no `end` — E enquanto a revelação suave
     * ainda está completando o texto (`revelacaoAtiva`, o fecho de ≤300ms da
     * bolha persistida): medido ao vivo, com os cartões já na tela o texto do
     * fecho os empurrava para baixo por esses 300ms — o mesmo reflow, só que
     * curto. Eles entram quando o texto para de crescer.
     */
    /**
     * A apresentação ainda está no botão "Continuar"?
     *
     * ★ **O turno de abertura traz a boas-vindas E a etapa 1 JUNTAS** — é um
     * turno só do servidor (`core/onboarding/turno.fechar_turno_de_abertura`).
     * Quem os separa em dois passos é o botão: *"só a partir dele que vamos
     * mostrar o componente de perguntas… senão fica muita coisa na cara e não
     * fica no esquema de etapas"* (owner, 18/09/2026).
     *
     * ⚠️ A pergunta é feita sobre `partesDeTools` (as partes CRUAS), nunca
     * sobre `partesResolvidas`: aquela é derivada de `partesParaRenderizar`,
     * que é justamente quem lê este computed — ler de lá fecharia um ciclo de
     * dependência reativa.
     *
     * ⚠️ E ela exige a boas-vindas PRESENTE: no turno da etapa 2 em diante não
     * há botão nenhum a esperar, e gatear ali esconderia a etapa para sempre.
     */
    apresentacaoAindaNoBotao() {
      if (this.avancouNaApresentacao) return false
      // ⚠️ **[18/09/2026] `avancouNaApresentacao` é `data`: MORRE no F5.**
      //
      // Parar na etapa 2 e recarregar trazia o "Continuar" de volta no topo da
      // conversa, com a etapa 1 escondida outra vez (achado do owner) — o
      // clique aconteceu, mas quem o registrava era estado de instância.
      //
      // A prova de que a apresentação avançou não é o clique: é a CONVERSA ter
      // seguido. Se esta bolha não é mais a última, existem turnos depois dela
      // — a pessoa já passou daqui, e segurar a etapa 1 seria esconder
      // histórico. O gate vale só enquanto a boas-vindas é o fim do fio, que é
      // exatamente o instante em que o botão tem sentido.
      if (!this.isLast) return false
      return (this.partesDeTools || []).some(ehCartaoDeBoasVindas)
    },
    partesParaRenderizar() {
      // A encenação do plano (§5.1) segura os cartões pela MESMA razão do
      // texto: a bolha mostra só o plano andando até a última etapa assentar.
      if (this.aguardandoEncenacaoDoPlano) return this.partesDeTools.filter(ehPropostaDecidivelAgora)
      // O passo 1 da apresentação: enquanto o "Continuar" não foi clicado, a
      // etapa fica fora da tela — a boas-vindas continua, porque é ela que
      // carrega o botão.
      if (this.apresentacaoAindaNoBotao) {
        return this.partesDeTools.filter((parte) => !ehCartaoDeOnboarding(parte))
      }
      // ★ [task #169] A revelação suave segura os cartões pelo mesmo motivo do
      // streaming (o texto do fecho os empurraria por ~300 ms) — e pelo mesmo
      // motivo ela NÃO pode segurar a proposta: enquanto o run espera decisão,
      // o texto revela e o `end` não vem, então "300 ms" viram a espera
      // inteira. Ver `partesAguardandoDecisao`.
      if (this.revelacaoAtiva) return this.partesDeTools.filter(ehPropostaDecidivelAgora)
      return this.partesDeTools
    },
    /**
     * Esta bolha nasceu do `end` do turno, e não do histórico.
     *
     * `duracao_s` é carimbado por `apiChat._onEventEnd` na mensagem que ele
     * acabou de criar; a conversa reaberta vem sem ele (`resource_messages.py`
     * não persiste o campo). É o único sinal, no shape da mensagem, de "este
     * turno terminou AGORA" — e por isso serve a dois consumidores:
     * a animação de chegada dos cartões e, desde o E-72, a releitura da lista
     * de arquivos entregues (a leitura anterior é mais velha que a entrega
     * deste run).
     */
    criadaAoVivo() {
      return this.duracaoDoTurno !== null
    },
    /**
     * Os cartões entram ANIMADOS só na mensagem que acabou de nascer do turno.
     * Na conversa reaberta a lista aparece pronta — animar dezenas de cartões
     * ao abrir uma conversa seria ruído, não chegada.
     */
    cartoesEntramAnimados() {
      return this.criadaAoVivo
    },
    /**
     * O turno ainda está correndo ([P1] da corrida do T023).
     *
     * Nesta bolha a resposta é o próprio `isStreaming` — ela SÓ existe em
     * streaming enquanto o turno vive; a persistida já é o depois. O nome
     * espelha o do renderer extraído de propósito: a moldura das duas
     * superfícies é comparada TEXTUALMENTE (`partes-do-turno.unit.js`), e é
     * essa comparação que impede as duas de divergirem em silêncio.
     *
     * [11/09/2026] Como a bolha em streaming não desenha cartão, aqui a
     * moldura recebe `false` na prática — a trava continua valendo no
     * `partes-do-turno.vue` (Fee Fixo), que desenha durante o turno.
     */
    turnoEmVoo() {
      return this.isStreaming
    },
    /**
     * O que esta bolha manda para o índice "Artefatos desta conversa"
     * (`store/artefato.js::registrarArtefatoDaConversa`): um registro por
     * cartão de dados que ela DESENHA — prévia ou cartão inline (o backend
     * decide por cartão via `ui.apresentacao`; `ui-registry/apresentacao.js`),
     * os dois com `artefato` E `parteReal` anexados pelo mixin (a linha do
     * índice abre o aside nos dois; `parteReal: null` só em cartão de escrita
     * ou sem painel na superfície, aí a linha rola até o cartão) — no `end`,
     * pela bolha persistida, junto com a entrada dos
     * cartões (a bolha em streaming não desenha cartão e por isso não registra
     * nada). Vazio fora da imersiva (`indiceDeArtefatosAtivo`), onde o índice
     * não existe e a action pode nem existir. É a bolha quem registra, e não
     * um util sobre `messages[].tool_calls`, porque só ela sabe o que passou
     * pelos gates do mixin (`$access`, veredito de schema, selo/recibo/falha).
     */
    artefatosParaRegistrar() {
      if (!this.indiceDeArtefatosAtivo) return []
      return artefatosDaMensagem({
        partes: this.partesResolvidas,
        mensagem: this.message,
      })
    },
    // Mesmo contrato de `modoArtefatoAtivo` (mixin): getter ausente na
    // superfície (Fee Fixo, ai-framework) vira `false`, e nada é despachado.
    indiceDeArtefatosAtivo() {
      const store = this.$store
      if (!store) return false
      return Boolean(store.getters[this.storeModule + '/indiceDeArtefatosAtivo'])
    },

    // ── O estado de erro do turno (G-2 da VERIFY it.2) ──────────────────────
    /**
     * O turno morreu e esta bolha é o vestígio dele.
     *
     * Quem a grava é o `apiChat._registrarTurnoComErro`, e ela nunca vem do
     * backend: um turno que falhou não tem mensagem persistida. Por isso ela
     * some no reload — o que a conversa reaberta mostra é o que o servidor
     * guardou, e inventar um erro que ele não registrou seria pior.
     */
    erroDoTurno() {
      return (this.message && this.message.erro_do_turno) || null
    },
    /**
     * A explicação do servidor, ou a nossa quando ele não deu nenhuma — nem uma
     * que seja log em vez de frase ([G-4] do design). Mesma função que o Modo
     * de Voz usa para decidir o que FALAR (spec-019 T004-delta) — uma fonte só
     * para as duas superfícies.
     */
    textoDoErroDoTurno() {
      return copyDoErroDoTurno(this.erroDoTurno && this.erroDoTurno.message)
    },
    // O que a linha de raciocínio mostra em vermelho quando o turno morreu —
    // vazio (sem erro) é o que a mantém no fluxo normal.
    erroParaALinhaDeRaciocinio() {
      return this.erroDoTurno ? this.textoDoErroDoTurno : ''
    },
    /**
     * O botão só existe quando há o que reenviar (o motor sabe qual foi o último
     * texto do usuário) e enquanto ninguém o usou nesta bolha.
     */
    mostrarTentarDeNovo() {
      if (!this.erroDoTurno) return false
      if (this.reenviado) return false
      return this.erroDoTurno.pode_tentar_de_novo !== false
    },
    rotuloTentarDeNovo() {
      return ROTULO_TENTAR_DE_NOVO
    },
    /**
     * O turno foi RECUSADO por saldo esgotado (`status: 402` — `gate_creditos.py`;
     * gravado por `apiChat._desfechoDeSaldoEsgotado`). A bolha mantém o texto
     * do servidor e ganha a porta para os créditos no lugar do "Tentar de novo"
     * (`pode_tentar_de_novo` já vem `false`): reenviar sem saldo só repete a
     * recusa.
     */
    saldoEsgotado() {
      return Boolean(this.erroDoTurno && this.erroDoTurno.saldo_esgotado === true)
    },
    copySaldoEsgotado() {
      return SALDO_ESGOTADO
    },
    // [VERIFY-3f/3g] Normaliza os dois shapes possíveis de `activeToolCalls`
    // (objeto `{tool, toolCallId}` do IA CRM, string crua do ai-framework/
    // Fee Fixo — ver o comentário da prop acima) numa única forma pro
    // template: sem isso, `tool.tool` numa string vira `undefined` (badge
    // com o nome errado + aviso de prop no console).
    toolCallsDecorados() {
      return this.activeToolCalls.map(function(tool, idx) {
        const ehObjeto = tool && typeof tool === 'object'
        const nomeDaTool = ehObjeto ? (tool.tool || '') : (tool || '')
        const chave = (ehObjeto && tool.toolCallId) ? tool.toolCallId : (nomeDaTool + '-' + idx)
        return { chave: chave, nomeDaTool: nomeDaTool }
      })
    },
    // Resposta que permaneceu cortada pelo teto de tokens mesmo após as
    // continuações automáticas do backend (spec-005). Só na mensagem
    // persistida — durante o streaming o veredito ainda não existe.
    mensagemTruncada() {
      return !this.isStreaming && Boolean(this.message && this.message.truncada)
    },
    // O raciocínio está "em streaming" enquanto o turno roda e a prosa ainda não
    // começou — é o que liga o auto-open/shimmer/timer do ThinkingSteps (R2).
    raciocinioEmStreaming() {
      return this.isStreaming && !this.content
    },
    textoDePreparo() {
      if (this.aguardandoDecisao) return 'Aguardando sua decisão'
      return this.persona.textoDePreparo || 'Pensando...'
    },

    /**
     * O passo ATUAL do turno — o texto com shimmer da linha única de
     * raciocínio (`raciocinio-linha`, dentro do `AssistantBlocks`), o ÚNICO
     * indicador de trabalho da bolha desde 11/09/2026: a pílula da topbar, o
     * "Montando a resposta...", o rótulo do rodapé e o card "Raciocínio da
     * IA" saíram.
     *
     * A copy é a de `utils/rotulo-do-turno.js` — "Pensando..." →
     * "Consultando cliente..." → "Elaborando resposta" (a máquina de fase,
     * spec-007). O rótulo da tool sai das PARTES do turno
     * (`toolPartsOrdenadas`, o canal tipado: `label` montado no backend a
     * partir de `BaseTool.LABEL`) e, quando a parte não trouxe `label`, do
     * espelho `TOOL_LABELS` do nome que o canal antigo guarda em `toolCalls`
     * — as duas fontes ficam porque o caminho legado do backend só escreve
     * `label` em tool de FRONT (medido no fio em 17/09/2026; o porquê inteiro
     * está no cabeçalho de `rotulo-do-turno.js`).
     *
     * ⚠️ Este é o passo CORRENTE, não o que está escrito na tela: quem
     * escreve é `passoExibidoDoTurno` (`chat-message.passo.js`), que segura
     * cada rótulo por um tempo mínimo legível antes de trocar.
     *
     * Os três getters só existem no namespace `aawz-intelligence-v2`
     * (`store/actions.js` `setFaseDoTurno`, guardada — ver
     * `superficies-do-chat.unit.js`); em outro `storeModule` (ai-framework/
     * Fee Fixo, que reusam esta bolha) o getter simplesmente não existe e o
     * rótulo cai no texto inicial da persona, sem erro.
     */
    passoAtualDoTurno() {
      // ★ merge PR #2242 — US-13 (spec-002): em `awaiting_approval` o stream
      // segue aberto por heartbeat esperando a decisão do card, e nada está
      // processando. A frase vinha do `textoDePreparo`, do bloco de preparo que
      // `desenvolvimento` removeu (a linha de raciocínio o substituiu) — sem
      // esta guarda a US-13 se perderia no merge.
      if (this.aguardandoDecisao) return 'Aguardando sua decisão'
      const store = this.$store
      const getters = (store && store.getters) || {}
      return rotuloDoTurno({
        fase: getters[this.storeModule + '/faseDoTurno'] || null,
        // ★ [review #2364, item D] O nó do Supervisor (`node-status`) entre a
        // tool em voo e a fase — é o que troca "Pensando..." por "Roteando…",
        // "Consolidando…" enquanto o grafo anda.
        noDoTurno: getters[this.storeModule + '/noDoTurno'] || null,
        partesDoTurno: getters[this.storeModule + '/toolPartsOrdenadas'] || [],
        toolsEmVoo: getters[this.storeModule + '/toolCalls'] || [],
        textoInicial: this.persona.textoDePreparo,
      })
    },
    /**
     * O `plano` vivo do turno (spec-001 `preparacao-reuniao`, D8.2) — os
     * passos de negócio de um atalho em execução, exibidos pelo
     * `plano-progress` dentro do `AssistantBlocks` no lugar da linha de
     * raciocínio ("um indicador por vez").
     *
     * Só existe no namespace `aawz-intelligence-v2` (`store/actions.js`
     * `setPlanoDoTurno`, dispatch no STORE fixo — ver
     * `apiChat.js::_onPlano`). Noutro `storeModule` (Fee Fixo, ai-framework)
     * o getter simplesmente não existe, e o Progress não aparece — mesma
     * degradação de `passoAtualDoTurno` acima.
     *
     * A FONTE muda com a bolha, e é isso que faz o Progress sobreviver ao fim
     * do turno (gap Q-0741 do QA de tela, spec-004):
     *
     * - AO VIVO, o store — o quadro corrente, que avança a cada `event: plano`;
     * - PERSISTIDA, `message.plano` — o quadro FINAL, gravado no `end`
     *   (`apiChat.js::_onEventEnd`) como `duracao_s` e `agent_slug` já são.
     *
     * A bolha persistida NUNCA lê o store: o valor de lá é do turno EM CURSO,
     * e apareceria na resposta anterior. Antes desta correção ela devolvia
     * `null` e o bloco sumia no `end` — o último `plano` do SSE chega menos de
     * um segundo antes dele, então o consultor via o começo da execução e nunca
     * os 4 passos riscados. Mensagem do histórico não tem a chave (o
     * `GET /messages` não traz o campo) e cai no `null`, sem Progress.
     */
    planoDoTurnoAtual() {
      // ⚠️ [21/09/2026] UM indicador de progresso por tela — a MESMA régua de
      // `itensPlano`, logo acima. Com o cartão flutuante do painel ligado, ele é
      // a superfície do progresso (e a ENCENA); o Progress "Preparando" desta
      // bolha chegava PRONTO, com todos os passos riscados, antes de a
      // encenação começar — dois relógios para o mesmo plano, um deles sem
      // relógio nenhum (achado do owner na tela, `/panorama` na Home IA).
      // Sem a prop (popup, painel do Hub, Fee-Based) nada muda.
      if (this.painelDeProgressoAtivo) return null
      if (!this.isStreaming) return (this.message && this.message.plano) || null
      const store = this.$store
      const getters = (store && store.getters) || {}
      return getters[this.storeModule + '/planoDoTurno'] || null
    },
    // Sem spinner em `awaiting_approval`: nada está processando, o run só
    // espera o clique em Confirmar/Rejeitar.
    mostrarSpinnerPreparo() {
      return !this.aguardandoDecisao
    },
  },
  watch: {
    // ★ [G-4] O texto técnico não vai à tela, mas também não some: o console é
    // onde ele serve. Fica no `watch` e não no computed porque computed
    // reexecuta a cada render — o log sairia repetido a cada token do turno.
    erroDoTurno: {
      immediate: true,
      handler(erro) {
        const bruto = String((erro && erro.message) || '').trim()
        if (!bruto || !pareceExcecaoCrua(bruto)) return
        console.warn('[IA] erro do turno em formato técnico:', bruto)
      },
    },
    // Cobertura defensiva: se o conteúdo de uma mensagem já persistida mudar
    // em algum fluxo futuro (edição, etc.), os botões de copiar acompanham.
    // Hoje o caminho normal é só o `mounted()` abaixo (mensagem streaming
    // nunca injeta — ver guard em `injetarAcoesMarkdown`).
    content() {
      this.$nextTick(this.injetarAcoesMarkdown)
    },
    // Registro idempotente (por `identidade`) — repetir é barato e a viva
    // (sem id) vira a persistida (com id) no mesmo lugar da lista. O que
    // SUMIU da lista desta bolha (prévia que virou `fallback-card` quando o
    // veredito do schema chegou `false`) é removido do índice.
    artefatosParaRegistrar: {
      immediate: true,
      handler(artefatos, anteriores) {
        this.removerArtefatosQueSumiram(artefatos, anteriores)
        this.registrarArtefatosDaConversa(artefatos)
      },
    },
  },
  mounted() {
    this.$nextTick(this.injetarAcoesMarkdown)
    this.carregarEntregasDoTurno()
  },
  methods: {
    /**
     * O "Continuar" da boas-vindas: revela a etapa e PEDE a rolagem.
     *
     * ★ **Por que o pedido é explícito, se o trilho já tem `ResizeObserver`.**
     * Ele existe e chama `scrollToBottom()` a cada crescimento — mas quem manda
     * lá é `isPinnedToBottom`, e depois de ler a boas-vindas (um cartão alto) a
     * pessoa está longe do fim: o observador cresce, a guarda diz "não estava
     * no fim" e a etapa nasce FORA da tela. Foi o que o owner mediu em
     * 18/09/2026 — *"ao clicar continuar ele mostra o conhecer seu escritório
     * mas não tem scroll automático"*.
     *
     * ⚠️ Não é um `scrollIntoView` daqui: ele sobe a cadeia inteira de
     * ancestrais roláveis e tira o composer do rodapé (§5.1 do CLAUDE.md). O
     * dono da rolagem é o trilho — a bolha só avisa.
     */
    avancarNaApresentacao() {
      this.avancouNaApresentacao = true
      this.$emit('avancou-apresentacao')
    },
    /**
     * Busca as entregas da CONVERSA — uma vez por bolha que tem run.
     *
     * ⚠️ Sem `id_run` não há o que recortar, e o pedido sairia para toda
     * conversa do Modo Chat: o guard é o que mantém a rota calada onde não
     * há entrega possível.
     *
     * ★ Não há N+1 apesar de cada bolha pedir: `apiArtefatos.listar` dedupa a
     * requisição EM VOO por conversa, e ao abrir uma conversa todas as bolhas
     * montam no MESMO tick — as N chamadas viram uma. A bolha que NASCE
     * depois (o turno que acabou de fechar) não acha requisição em voo e faz
     * a dela, que é justamente onde a entrega nova aparece; um memo com
     * validade devolveria a lista de antes dela — verde na tela, arquivo
     * invisível.
     *
     * Falha não vira snack: ninguém pediu esta leitura, e um aviso por bolha
     * ao abrir uma conversa com dez turnos seria dez avisos. A bolha fica sem
     * a seção, como fica quando o turno não entregou nada.
     */
    carregarEntregasDoTurno() {
      if (!this.idRunDaMensagem || !this.idConversa) return
      return apiArtefatos
        .listar({ id_conversa: this.idConversa })
        .then((r) => {
          if (!r || r.status !== 200) return
          const valor = r.value || {}
          this.artefatosDaConversa = valor.artefatos || []
        })
    },
    /**
     * Baixa UMA entrega (US-4).
     *
     * `indice` é o contrato de `ComposerAttachments` (o mesmo de `remover`):
     * o componente decora os itens, então quem tem o objeto original é quem
     * passou a prop.
     *
     * Três coisas que não são acidentais:
     *
     *  - **403/404 chegam com HTTP 200 e o status no CORPO** (contrato da
     *    plataforma). O desfecho é lido de `r.status`, nunca de um `catch`;
     *    `catch` aqui só pegaria exceção de JS.
     *  - **Sem `value` não há download.** O envelope de recusa vem com
     *    `value: null`, e chamar `downloadBase64(undefined, ...)` salvaria um
     *    arquivo vazio com o nome certo — a pior falha possível, porque
     *    parece sucesso.
     *  - **O loading sai no `finally`**, inclusive na recusa: item que fica
     *    girando para sempre depois de um 403 é o beco invisível.
     */
    baixarEntrega(indice) {
      const item = this.entregasDoTurno[indice]
      if (!item) return
      const chave = chaveDoArquivo(item)
      if (this.baixandoPorChave[chave]) return

      this.marcarBaixando(chave, true)
      return apiArtefatos
        .baixar({ id_conversa: this.idConversa, id_objeto: item.id_objeto })
        .then((r) => this.concluirDownload(r))
        .finally(() => this.marcarBaixando(chave, false))
    },
    // Objeto NOVO a cada mudança: o Vue 2 não detecta chave adicionada num
    // objeto reativo, e a alternativa (`$set`) é a que o CLAUDE.md do repo
    // desaconselha por ser fácil de esquecer.
    marcarBaixando(chave, ligado) {
      const mapa = { ...this.baixandoPorChave }
      if (ligado) mapa[chave] = true
      else delete mapa[chave]
      this.baixandoPorChave = mapa
    },
    concluirDownload(r) {
      const valor = (r && r.value) || null
      if (r && r.status === 200 && valor && valor.base64) {
        downloadBase64(valor.base64, valor.name, valor.extension)
        return
      }
      // A recusa do servidor (403 objeto de outra conversa, 404 entrega que
      // não existe mais) tem `message` própria — ela é mais útil que qualquer
      // frase da casa, e o `$showSnack(r)` já infere texto e cor do envelope
      // (regra do design-system: passar a RESPOSTA, não remontá-la à mão).
      if (r && r.message) return this.$showSnack(r)
      // Envelope mudo: aí sim texto fixo, com a próxima ação.
      this.$showSnack({
        text: ENTREGAS_DA_MENSAGEM.ERRO_SEM_MENSAGEM,
        color: 'error',
        button: true,
      })
    },
    /**
     * Reenvia o último texto do usuário pela superfície DONA do turno.
     *
     * O caminho é o índice por namespace (`ui-registry/execucao.js`), o mesmo do
     * botão "Abrir" do cartão de ação — e pelo mesmo motivo: importar o
     * singleton `apiChat` aqui faria o drawer do Fee Fixo reenviar a pergunta
     * pela conversa do chat do CRM.
     */
    // A MESMA porta do rodapé da lateral e do "Meus créditos" do Ctrl+K: o
    // modal (`global-modals.vue`) faz o próprio `carregarSaldo`, então o canal
    // é o contrato inteiro — sem payload.
    abrirCreditos() {
      GlobalBus.$emit(MODAL.AI_FRAMEWORK_CREDITOS)
    },
    tentarDeNovo() {
      if (this.reenviando || this.reenviado) return
      this.reenviando = true
      const namespace =
        (this.erroDoTurno && this.erroDoTurno.namespace) || this.storeModule
      // `reenviado` só no sucesso: a rejeição avisa e DEIXA o botão — marcar
      // sucesso no `then` após o `catch` escondia o retry de um reenvio que
      // nem saiu.
      return reenviarUltimoTurno(namespace)
        .then((r) => {
          // `null` (sem executor no namespace, sem envio anterior) é o mesmo
          // caso: nada saiu e só o console soube — cai na copy da casa.
          if (r === null) return this.avisarReenvioFalhou()
          this.reenviado = true
        })
        // A rejeição aqui é sempre do lado de cá (exceção JS — `sendMessage`
        // devolve envelope, nunca lança; o erro do SERVIDOR vira bolha por
        // `_registrarTurnoComErro`). A `message` dela ("Network Error" do
        // axios) não é frase de servidor e a régua de `copyDoErroDoTurno`
        // não a reconhece como log — ia crua ao snack.
        .catch(() => this.avisarReenvioFalhou())
        .finally(() => {
          this.reenviando = false
        })
    },
    // Saída única do reenvio que não saiu: a copy da casa já traz o próximo passo.
    avisarReenvioFalhou() {
      this.$showSnack({
        text: COPY_ERRO_SEM_MENSAGEM,
        color: 'error',
        button: true,
      })
    },
    onAsk(texto) {
      this.$emit('ask', texto)
    },
    // O canal genérico do contrato (`@respond({toolCallId, acao, payload})`). A
    // parte viaja junto porque quem trata lá em cima precisa saber de qual
    // cartão veio sem ter que reabrir o turno.
    onRespond(parte, evento) {
      this.$emit('respond', { parte: parte, ...evento })
    },
    /**
     * Clique no card de prévia do painel de artefato (Fase 2b, plano
     * `moonlit-conjuring-sun`). Só as partes que `montarPreviewDeArtefato`
     * (`renderiza-partes.js`) montou trazem `parteReal` — as demais (cartão
     * real, fallback, selo, recibo) nunca emitem `@abrir`, mas o guard fica
     * aqui como defesa contra um clique órfão.
     */
    onAbrirArtefato(parte) {
      if (!parte || !parte.parteReal) return
      const store = this.$store
      if (!store || typeof store.dispatch !== 'function') return
      store.dispatch(this.storeModule + '/abrirArtefato', parte.parteReal)
    },
    /**
     * Clique no card de prévia JÁ ativo (toggle) — o card emite `@fechar` em
     * vez de `@abrir` quando ele já é o artefato aberto no aside (ver
     * `artefato-preview-card.vue::onAbrir`). Sem payload: `fecharArtefato`
     * só zera `aberto`, mantém `parte` retida (ver `store/artefato.js`).
     */
    onFecharArtefato() {
      const store = this.$store
      if (!store || typeof store.dispatch !== 'function') return
      store.dispatch(this.storeModule + '/fecharArtefato')
    },
    // Ver `artefatosParaRegistrar`. Só despacha na imersiva (o computed já
    // devolve vazio fora dela), então nunca cai em "unknown action" nas
    // superfícies sem o slice (Fee Fixo, ai-framework).
    registrarArtefatosDaConversa(artefatos) {
      if (!artefatos || !artefatos.length) return
      const store = this.$store
      if (!store || typeof store.dispatch !== 'function') return
      const namespace = this.storeModule
      artefatos.forEach(function (artefato) {
        store.dispatch(namespace + '/registrarArtefatoDaConversa', artefato)
      })
    },
    // Ver o watcher de `artefatosParaRegistrar`. Só olha o que ESTA bolha
    // tinha antes — nunca a lista inteira do store, que é das outras também.
    removerArtefatosQueSumiram(atuais, anteriores) {
      if (!anteriores || !anteriores.length) return
      const store = this.$store
      if (!store || typeof store.dispatch !== 'function') return
      const namespace = this.storeModule
      const aindaPresentes = {}
      ;(atuais || []).forEach(function (artefato) {
        aindaPresentes[artefato.identidade] = true
      })
      anteriores.forEach(function (artefato) {
        if (aindaPresentes[artefato.identidade]) return
        store.dispatch(namespace + '/removerArtefatoDaConversa', artefato.identidade)
      })
    },
    onFeedback(payload) {
      this.$emit('feedback', payload)
    },
    onOpenService(payload) {
      this.$emit('open-service', payload)
    },
    onResponderPerguntas(texto) {
      this.$emit('responder-perguntas', texto)
    },
    // Copia texto pro clipboard via o util compartilhado (src/utils/Clipboard.js),
    // que já tem o guard de disponibilidade da Clipboard API — só soma o
    // feedback de sucesso/erro específico deste componente.
    async copyText(texto, successMessage) {
      try {
        await copy(texto)
        this.$showSnack({
          text: successMessage,
          color: 'success',
          button: true,
        })
      } catch (e) {
        console.error(e)
        this.$showSnack({
          text: COPY_CHAT_MESSAGE.erroCopiar,
          button: true,
        })
      }
    },
    // Injeta wrapper + botão de copiar em cada <table>/<pre> ainda não
    // processado dentro do HTML cru que o vue-markdown gerou. Só roda pra
    // mensagem já persistida E com o texto inteiro na tela: durante o
    // streaming (e durante o fecho da revelação suave) o vue-markdown
    // re-renderiza o innerHTML inteiro a cada avanço (tabela vira nó novo
    // toda hora), então processar ali seria caro e a tabela pode estar
    // incompleta — os botões aparecem assim que a mensagem se estabiliza
    // (`concluirRevelacao` chama de novo).
    injetarAcoesMarkdown() {
      if (this.isStreaming || this.revelacaoAtiva || !this.$el) return
      injetarBotaoTabela(this.$el, this.copyText)
      injetarBotaoCodigo(this.$el, this.copyText)
    },
    // [VERIFY-3h, SHOULD-2 review-frontend-pr2242] US-7 (events.json
    // `token.substitui`): o token com `substitui: true` já dispara
    // `resetResponseTokens` em `apiChatStream.js::_onEventToken` (o buffer
    // é reiniciado ANTES do texto corrigido ser enfileirado) — este array
    // (`this.streamingTokens`) NUNCA contém um objeto `{token, substitui}`,
    // só string pura (`data.token || ''`, sempre). O ramo que tratava tokens
    // em forma de objeto era código morto (confirmado: nenhum ponto do
    // stream enfileira objeto).
    textoDosTokens(tokens) {
      return tokens.join('')
    },
  },
}
</script>

<template>
  <div
    class="chat-message mb-4"
    :class="
      isUser ? 'chat-message--user d-flex justify-end' : 'd-flex justify-start'
    "
  >
    <!-- Mensagem do usuario -->
    <template v-if="isUser">
      <div class="chat-message__usuario">
        <!-- Anexos ACIMA da bolha, alinhados com ela — o mesmo desenho que a
             fila do composer, pelo mesmo componente. -->
        <ComposerAttachments
          v-if="temAnexos"
          somente-leitura
          class="chat-message__anexos"
          :arquivos="anexosDaMensagem"
        />
        <div class="message-bubble user-bubble ia-texto-corpo pa-2">
          <div v-if="comandoDaFala" class="chat-message__comando az-gap-xsmall" data-teste="fala-comando">
            <ComandoChip
              com-fundo
              :rotulo="comandoDaFala.rotulo"
            />
            <span v-if="comandoDaFala.argumento" data-teste="fala-comando-argumento">
              {{ comandoDaFala.argumento }}
            </span>
          </div>
          <div v-else>{{ content }}</div>
          <!-- A conversa REABERTA não tem mais o
               eco local (`anexosDaMensagem` acima já veio vazio) — o que
               resta é o bloco técnico persistido. [S-3, design-conformance
               05/09] MESMO componente do anexo ao vivo (`ComposerAttachments
               somente-leitura`, acima), não mais um chip à parte — era o
               mesmo anexo com duas anatomias na mesma bolha. O adaptador
               (`paraItemDeAnexo`) nunca expõe `upload_id` como texto visível
               — só como chave interna do componente. -->
          <ComposerAttachments
            v-if="temAnexosPersistidos"
            somente-leitura
            class="chat-message__anexos"
            :arquivos="itensDeAnexosPersistidos"
          />
        </div>
      </div>
    </template>

    <!-- Mensagem do assistant -->
    <template v-else-if="isAssistant || isStreaming">
      <div class="assistant-content">
        <!-- D6 — quem respondeu este turno (spec-010, [T027]/US-7). Substitui
             o seletor de agente do composer: o gestor não escolhe mais, só vê
             quem o Supervisor roteou. Antes do conteúdo — é a identidade da
             resposta, não uma nota de rodapé.

             RF-G2 — turno multi-agente (fan-out) mostra UM badge POR agente,
             não só o primeiro; `badgesDoTurno` já resolve a ordem e os 4
             estados do contrato `ui-components.md` §1.1. Gap `az-gap-xsmall`
             (4px, "entre ícones adjacentes" no design system) entre badges;
             `flex-wrap` porque 3+ agentes numa bolha estreita têm que quebrar
             linha, não vazar da bolha. -->
        <div
          v-if="mostrarAgenteBadge"
          class="d-flex flex-wrap align-center az-gap-xsmall mb-2"
        >
          <AgentBadge
            v-for="(badge, index) in badgesDoTurno"
            :key="index + '-' + (badge.agentSlug || 'sem-agente')"
            :hub="badge.hub"
            :agent-slug="badge.agentSlug"
            :agent-label="badge.agentLabel || ''"
            :motivo="badge.motivo"
            :estado="badge.estado"
          />
        </div>

        <!-- Blocos da resposta: raciocínio, deliberação do painel, o texto
             (slot, porque só este componente conhece a persona), próximos
             passos e perguntas em aberto. Substituíram o `thinking-steps.vue`,
             que ficou sem consumidor e saiu do repo. -->
        <AssistantBlocks
          :painel="painel"
          :plano="planoDoTurnoAtual"
          :passos="passosDoRaciocinio"
          :passo-atual="passoExibidoDoTurno"
          :passo-de-trabalho="passoPrendeATela"
          :duracao-segundos="duracaoDoTurno"
          :rotulo-do-tempo="rotuloDoTempoDoTurno"
          :auxiliares="auxiliaresDoRaciocinio"
          :erro-do-turno="erroParaALinhaDeRaciocinio"
          :streaming="trabalhando"
          :perguntas-ja-no-formulario="perguntasAoGestor"
        >
          <!-- [T101] O que o turno FEZ, acima do texto (ver o slot em
               `assistant-blocks.vue`). Cada bloco some sozinho quando o canal
               chega vazio — o `v-if` está na raiz dos três componentes.

               ★ NÃO passa por `persona.mostraFontes`, e a decisão é da US-6
               (AC: "habilitar a exibição do cartão de fonte web nela antes de
               liberar a busca, ou não liberar a busca nela") — esta é a
               primeira alternativa. `mostraFontes` existe para esconder NOME
               DE TABELA DO BANCO (AC-2.6, `chat-message-fontes.vue`), risco
               que o cartão de fonte WEB não tem: ele mostra título, domínio,
               URL pública e data de coleta. Gatear um pelo outro esconderia a
               procedência de um número de mercado justamente nas duas personas
               que aconselham.

               ⚠️ E são DUAS personas com `mostraFontes: false` hoje
               (`Personas.js:98` e `:140`) mais DOIS hubs (`Hubs.js:44` e
               `:51`), não a única que a spec supõe. -->
          <template v-slot:antes-do-texto>
            <!-- Plano do turno ACIMA da resposta (17/09/2026): as etapas são o
                 caminho até o texto, não um anexo depois dele. Some sozinho sem
                 itens (v-if na raiz do componente). -->
            <ChatMessagePlano
              :itens="itensPlano"
              :comando="comandoDoTurno"
              :ativo="isStreaming"
              :encenavel="planoEncenavel"
            />
            <BuscaWeb :eventos="eventosDeBusca" />
            <CodigoExecutado :eventos="eventosDeCodigo" />
            <ArquivoGerado :eventos="eventosDeArquivo" />
          </template>

          <!-- ★ [20/09/2026] O texto ENTRA animado (`iv2-parte`: fade + 10px
               de subida, 220ms, o mesmo gesto dos cartões). Ele passou a
               aparecer DEPOIS da encenação, e sem transição a troca lia como
               um salto — *"quando aparecer, aparecer com transição/animação
               suave"* (owner). `prefers-reduced-motion` já é tratado pela
               classe em `design/efeitos.sass`. -->
          <transition name="iv2-parte">
            <div v-if="content" class="ia-message-content">
              <AawzMarkdownRender
                :source="conteudoRenderizado"
                :allow-html="persona.permiteHtml"
                :no-linkify="!linkifyAtivo"
                :postrender="postrenderExtra"
              />
            </div>
          </transition>
        </AssistantBlocks>

        <!-- Os cartões do turno, em um só lugar (spec-001 [T011]). Cartão novo
             é uma entrada no UI_REGISTRY, não uma linha aqui.

             ★ [I-13] O invólucro existe pelo `az-gap`: sem ele, dois cartões
             seguidos ficavam colados AQUI e com 16px de respiro no renderer
             extraído — a mesma lista, dois ritmos. -->
        <!-- [11/09/2026] Os cartões entram no `end`, ABAIXO do texto, com a
             animação de entrada (`iv2-parte-*`, `design/efeitos.sass`) e
             escalonados — `appear` porque quem os desenha é a bolha
             persistida, montada inteira no `end`; só na mensagem que acabou
             de nascer (`cartoesEntramAnimados`), nunca no histórico. A bolha
             em streaming não desenha cartão (ver "A ordem é UMA" no topo do
             arquivo): a linha de raciocínio já diz que a tool está rodando. O
             invólucro `.iv2-parte` (fora da moldura, que segue idêntica nas
             duas superfícies) é quem anima e quem carrega o crossfade da
             janela de validação (`parte.validando`). -->
        <transition-group
          v-if="partesResolvidas.length"
          name="iv2-parte"
          tag="div"
          class="d-flex flex-column az-gap mt-2"
          :appear="cartoesEntramAnimados"
        >
          <!-- `data-artefato-id` (só no cartão de dados): é por ele que o
               índice de artefatos rola até o cartão inline e o realça
               (`messages.vue::rolarAteArtefato`). -->
          <div
            v-for="parte in partesResolvidas"
            :key="parte.identidade"
            class="iv2-parte"
            :class="{ 'iv2-parte--validando': parte.validando }"
            :data-artefato-id="parte.ancoraDeArtefato"
          >
            <component
              :is="parte.componente"
              v-bind="parte.props"
              :state="parte.state"
              :tool-call-id="parte.toolCallId"
              :id-proposta="parte.idProposta || null"
              :label="parte.label"
              data-teste="parte-do-turno"
              :data-tool-call-id="parte.toolCallId || null"
              :turno-em-voo="turnoEmVoo"
              :somente-leitura="parte.somenteLeitura === true"
              :etapa-historica="etapaHistorica"
              :resposta-do-cartao="respostaDoCartao"
              :estado-do-run="estadoDoRun"
              @respond="onRespond(parte, $event)"
              @avancar="avancarNaApresentacao"
              @open-service="onOpenService"
              @ask="onAsk"
              @abrir="onAbrirArtefato(parte)"
              @fechar="onFecharArtefato"
            />
          </div>
        </transition-group>

        <!-- [spec-008 T028] As ENTREGAS do turno (US-4): o arquivo que o
             agente produziu, para baixar. MESMO componente do anexo da bolha
             do usuário (`ComposerAttachments somente-leitura`, no topo deste
             template) — arquivo com nome, tipo e tamanho é a mesma coisa para
             quem olha, e duas anatomias na mesma conversa foi o defeito que o
             S-3 corrigiu do outro lado.

             Fica ABAIXO dos cartões e ACIMA das fontes: é produto do turno,
             não nota de rodapé, e a ordem da bolha é UMA (raciocínio → painel
             → texto → cartões → entregas → fontes). -->
        <!-- [spec-003 T301 / US-5] O gráfico da análise, INLINE. Fica ACIMA da
             lista de entregas porque é conteúdo da resposta — a lista é o
             rodapé de arquivos. Ele desenha sozinho: os bytes vêm por
             `apiArtefatos.baixar` dentro do próprio componente, porque a
             entrega é metadado e uma imagem precisa dos bytes ANTES do clique.
             Sem gráfico entre as entregas, nada renderiza. -->
        <GraficoDoTurno
          v-if="temEntregas"
          :graficos="graficosDoTurno"
          :id-conversa="idConversa"
        />

        <div v-if="temEntregas" class="mt-3" data-teste="entregas-do-turno">
          <div class="az-text-secondary az-size-12 mb-1">
            {{ tituloDasEntregas }}
          </div>
          <ComposerAttachments
            somente-leitura
            com-download
            :arquivos="entregasDoTurno"
            :baixando-por-chave="baixandoPorChave"
            @baixar="baixarEntrega"
          />
        </div>

        <!-- O turno morreu (G-2 da VERIFY it.2). O snack já mostrou a mesma
             explicação, mas ele some em segundos: é esta bolha que fica no
             lugar onde a resposta deveria estar, com o motivo e a saída.
             [feedback do usuário] Mesmo molde do bloco de conversa
             (`_ia-block-card.sass`): cabeçalho com título + a ação como
             hiperlink no fim, corpo com o fato por extenso.
             [bug corrigido, 31/08] Sem ícone no cabeçalho — mesmo pedido do
             usuário que tirou o `error-circle` do `fallback-card.vue`: o
             texto ("Não foi possível concluir") já é o sinal de erro.
             [feedback do usuário, 02/09] `fita` — mesmo tratamento visual de
             `ia-confirm-action.vue`/`fallback-card.vue`/`acao-oferecida-
             card.vue`: faixa de fundo no cabeçalho (era branco) e título na
             escala pequena da família de escrita (12px, era 14px via
             `compacto`). O corpo (14px, `motivo-do-erro` abaixo) NÃO muda —
             ver [G-5 do design] logo ali: aquele tamanho é do FATO, não do
             título. -->
        <div
          v-if="erroDoTurno"
          class="chat-message-erro-do-turno ia-block-card mt-2"
          data-teste="turno-com-erro"
        >
          <CartaoCabecalho :titulo="textos.tituloErroDoTurno" fita compacto>
            <template v-if="mostrarTentarDeNovo" v-slot:meta>
              <button
                type="button"
                class="ia-block-card__abrir"
                :disabled="reenviando"
                data-teste="tentar-de-novo"
                @click="tentarDeNovo"
              >
                {{ rotuloTentarDeNovo }}
              </button>
            </template>
          </CartaoCabecalho>
          <div class="ia-block-card__corpo">
            <!-- ★ [G-5 do design] O FATO é o corpo da bolha (14px). Em 12px
                 muted ele virava metadado, e o olho lia o botão antes do
                 motivo — hierarquia invertida no único lugar que explica o
                 que houve. -->
            <div class="az-text-primary az-size-14" data-teste="motivo-do-erro">
              <!-- ★ Saldo esgotado: o gate manda a recusa em MARKDOWN
                   (`**Central de IA › Créditos**`, parágrafos) — o mesmo
                   renderizador da resposta, sem HTML (a fonte é o servidor,
                   mas a régua XSS multi-tenant vale para toda bolha). -->
              <AawzMarkdownRender
                v-if="saldoEsgotado"
                :source="textoDoErroDoTurno"
                :allow-html="false"
              />
              <template v-else>{{ textoDoErroDoTurno }}</template>
            </div>
            <!-- A saída é o botão "Meus créditos" do rodapé da lateral (que
                 pulsa neste instante — `saldo-creditos-rodape.vue`) — e a
                 mesma porta aqui, para quem está com a lateral recolhida. -->
            <template v-if="saldoEsgotado">
              <p
                class="az-text-primary az-size-14 az-muted mt-3 mb-0"
                data-teste="orientacao-saldo-esgotado"
              >
                {{ copySaldoEsgotado.ORIENTACAO }}
              </p>
              <BaseButton
                primary
                fit-content
                min-width="auto"
                class="mt-3"
                data-teste="abrir-creditos"
                @click="abrirCreditos"
              >
                {{ copySaldoEsgotado.ABRIR_CREDITOS }}
              </BaseButton>
            </template>
          </div>
        </div>

        <!-- Aviso discreto de corte residual (spec-005): o backend já tentou
             continuar automaticamente; se ainda assim cortou, o gestor precisa
             saber que o texto pode estar incompleto. -->
        <output
          v-if="mensagemTruncada"
          class="chat-message-truncada mt-2 text-caption"
        >
          {{ textos.avisoTruncada }}
        </output>

        <!-- Formulário de `perguntar_ao_gestor`: entra no `end`, abaixo do
             texto, com a mesma entrada dos cartões (`iv2-parte`) — `appear`
             só na mensagem recém-nascida, como o laço de cartões acima. -->
        <transition name="iv2-parte" :appear="cartoesEntramAnimados">
          <ManagerQuestions
            v-if="mostrarPerguntasAoGestor"
            class="mt-3"
            :perguntas="perguntasAoGestor"
            :editavel="perguntasEditaveis"
            :respostas-enviadas="respostasDoFormulario"
            @responder="onResponderPerguntas"
          />
        </transition>
        <!-- Servicos citados (AC-4.1) -->
        <ServicosCitados
          v-if="mostrarServicosCitados"
          :id-conversa="idConversa"
          :itens="servicosCitados"
          @open-service="onOpenService"
        />

        <!-- Fontes: expõe nome de tabela do banco, por isso fica fora das
             personas voltadas ao cliente — AC-2.6. A faixa de dezenas de
             pílulas (uma por CHAMADA de tool, porque o backend concatena sem
             consolidar) virou UM chip com popover no hover. -->
        <ChatMessageFontes
          v-if="mostrarFontes"
          class="mt-2"
          :sources="sources"
        />

        <!-- Os polegares só fazem sentido sobre uma resposta LEGÍVEL: com o
             texto retido pela fila eles ficavam sozinhos embaixo do casco. -->
        <!-- ★ [spec-002 T050..T052/T051b] Fontes da INTERNET — cartão próprio,
             nunca dentro da linha "Fontes:" acima (IA-001 D5: aquela linha é
             das fontes internas, e misturar as duas apaga a distinção de
             origem que o consultor precisa ver). Ele decide sozinho se
             aparece: sem busca no turno, ou em persona com `mostraFontes:
             false`, não renderiza nada — por isso não há `v-if` aqui.
             `fontes-persistidas` é `message.fontes_web` (T051b) — presente
             na mensagem RECARREGADA, para o cartão sobreviver ao F5; ausente
             no streaming, onde ele cai para o canal transiente de sempre.
             `ao-vivo` (MUST-2, review PR #2328) é o MESMO `isStreaming` desta
             bolha: só a bolha em streaming pode ler o canal transiente —
             sem isso, toda resposta anterior da conversa (sem
             `fontesPersistidas` própria) mostrava a fonte do turno ALHEIO
             que estivesse em voo. -->
        <ChatMessageFontesWeb
          class="mt-2"
          :persona="persona"
          :fontes-persistidas="message && message.fontes_web"
          :ao-vivo="isStreaming"
        />

        <!-- ★ [E-72, sobre o E-64] Os ARQUIVOS que o agente entregou neste
             turno — `.xlsx`, `.pdf`, `.py` do workspace, com o clique ligado
             ao download real. NÃO é o cartão de dado do `ui-registry` (aquele
             é `ui.component` de tool); é arquivo mesmo, e até esta task
             nenhuma tela o pedia: o backend entregava e o consultor não
             recebia. Ele decide sozinho se aparece — turno sem entrega não
             renderiza nada, por isso não há `v-if` aqui.
             `ao-vivo` é o MESMO `isStreaming` da bolha (só ela lê o canal
             transiente `arquivoStreaming`, pelo motivo do MUST-2 do cartão de
             fonte web); `ancora-do-run` vem do `messages.vue` e marca a bolha
             persistida que representa o run, para o mesmo arquivo não sair
             duas vezes quando um run grava duas mensagens de assistente. -->
        <ChatMessageArtefatos
          class="mt-2"
          :id-conversa="idConversa"
          :id-run="message && message.id_run"
          :ancora-do-run="ancoraDeArtefatos"
          :ao-vivo="isStreaming"
          :recem-entregue="criadaAoVivo"
        />

        <ChatMessageFooter
          :is-streaming="trabalhando"
          :message-id="messageId"
          :current-feedback="currentFeedback"
          :current-comentario="currentComentario"
          @feedback="onFeedback"
        />
      </div>
    </template>
  </div>
</template>

<style lang="sass" scoped>
// As classes de entrada dos cartões do turno (`iv2-parte-*`) — o
// `<transition-group>` do laço de cartões as aplica no invólucro de cada
// parte, e elas viajam com o componente pelo `@import` (§12 do CLAUDE.md).
@import '@modules/aawz-intelligence-v2/design/efeitos.sass'

.chat-message
  align-items: flex-start

// ⚠️ O teto de largura NÃO mora aqui — mora no `.chat-message__usuario`.
// A bolha é filha de um wrapper que se dimensiona pelo conteúdo dela, então
// `max-width: 85%` criava referência circular: o Chrome ignora a porcentagem ao
// medir a contribuição intrínseca (o wrapper fica do tamanho natural do texto) e
// só DEPOIS aplica os 85% na bolha — que passa a ser menor que o próprio texto e
// quebra linha sozinha. Era o motivo de "e o divo11" sair em duas linhas.
.message-bubble
  word-break: break-word
  border-radius: 16px

// Balão do usuário NEUTRO, não colorido — decisão de produto que sobrepõe o
// verde de marca do §7.3.
// A plataforma é white-label: fixar uma cor de marca no balão da mensagem do
// próprio usuário não sobrevive a escritório com identidade diferente. O verde
// do protótipo foi tentado e revertido. Neutro também resolve o contraste de
// graça: --neutral-900 sobre --neutral-100 = 13.55 (AA pede 4.5), contra 2.69
// do verde de marca com texto branco.
// A tipografia (14px/20px, o papel `corpo`) é a classe `.ia-texto-corpo` de
// `design/_ia-texto.sass`, no template; o porquê de fixá-la (a `text-body-2`
// do Vuetify vencia por ordem de bundle) está lá. Aqui a caixa e a cor.
.user-bubble
  background: var(--neutral-100)
  border: 1px solid var(--border-input)
  color: var(--neutral-900)
  border-radius: 16px 16px 6px 16px

// Resposta do assistant sem "caixa" — texto solto, largura cheia (sem
// avatar do lado sobrando espaço), estilo ChatGPT/Claude.ai.
.assistant-content
  width: 100%
  word-break: break-word

// ★ A TIPOGRAFIA da resposta NÃO mora aqui (leva 2 da escala, 21/09/2026):
// o papel `resposta` (16/24) e o override do `.markdown-style` global
// (`p`/`li`/tabela/`h1..h4`/`code`) vivem em `design/_ia-texto.sass`, sob
// `.ia-message-content .markdown-style`. Uma regra `::v-deep` aqui compila
// para (0,3,x) e venceria a da partial em silêncio — foi assim que a
// resposta ficou meses em 13px por um `font-size` escrito neste scoped.

// [feedback do usuário] "BaseTable é a referência" — quando o modelo escreve
// a tabela em markdown puro em vez de chamar a tool (comportamento do
// modelo, fora do escopo do frontend — ver nota acima), o cabeçalho dela não
// pode ler diferente do `CartaoTabela` (`ui-registry/cartao-tabela.vue`) que
// desenha a MESMA informação quando a tool É chamada. Aqui fica só o FUNDO
// da faixa (não é tipografia); GeneralSans, tamanho, entrelinha e peso do
// `<th>` são a regra `.ia-message-content .markdown-style th` da partial.
.ia-message-content ::v-deep .markdown-style th
  background: var(--sidebar-warm-bg)

// ── Estados do turno (spec-001 `plataforma-por-chat`) ───────────────────────

// `<output>` é inline por padrão (traz role=status implícito, S6819); o aviso
// ocupa a própria linha abaixo da bolha, como quando era uma <div>.
// --gray-7: cor de TEXTO com contraste AA sobre a bolha (--gray-3 é token de
// borda/fundo — 1.21:1, invisível; achado do review do PR #1997).
.chat-message-truncada
  display: block
  color: var(--gray-7)
  font-style: italic

// A coluna do turno do usuário: anexos em cima, bolha embaixo, os dois
// encostados à DIREITA. O pai já é `justify-end`; aqui é o eixo cruzado.
.chat-message__usuario
  display: flex
  flex-direction: column
  align-items: flex-end
  gap: 4px
  // O teto da mensagem do usuário. AQUI, e não na bolha: este elemento é filho
  // direto da linha (largura cheia), então a porcentagem tem contra o que
  // resolver. Curto continua colado ao conteúdo; longo cresce até 85% e só
  // então quebra.
  max-width: 85%
  // Sem isto, `min-width: auto` do flex impede o encolhimento e uma palavra
  // longa (URL, código de ativo) estoura o teto em vez de quebrar.
  min-width: 0

// Chip + argumento na mesma linha, quebrando como texto quando o argumento é longo.
.chat-message__comando
  display: flex
  flex-wrap: wrap
  align-items: center

// A fila vem do composer, onde ela carrega o respiro da caixa. Na bolha esse
// respiro é do turno, não dela — por isso zerado aqui.
.chat-message__anexos ::v-deep .composer-attachments__lista
  padding: 0
  justify-content: flex-end
</style>
